<template>
  <!-- Add RFID Modal -->
  <v-tailwind-modal v-model="addpair_modalshow" @confirm="addpair_confirm" @cancel="cancel">
    <template v-slot:title>{{ $t('pairing.addrfid') }}

    </template>
    <template v-slot:icon>
      <IconAddRfid class="text-skin-b-list-mute" />
    </template>
    <div class="w-full sm:grid sm:gap-4 sm:grid-cols-2">

      <div class="form-group mb-4 sm:mb-0">
        <SelectWithLabelIcon v-model="addpairtype" :label="$t('pairing.rfidtype')"
          :placeholder="$t('pairing.rfidassign')" icon="IconStacks">
          <template v-slot:options>
            <option value="rfid" selected>{{$t('pairing.chargerfid')}}</option>
            <!--<option value="rfid_user">Benutzer-Ladekarte</option>-->
            <!--<option value="rfid_checkin">Ladekarte für easyCheckIn</option>-->
            <!--<option value="rfid_local">Ladekarte ohne OCPP-Funktion</option>-->
            <option value="fc_rfid_pair">{{$t('pairing.functionrfid')}}: {{$t('pairing.functionrfidlearn')}}</option>
            <option value="fc_rfid_charge">{{$t('pairing.functionrfid')}}: {{$t('pairing.functionrfidsolar')}}</option>
            <option value="fc_rfid_lock">{{$t('pairing.functionrfid')}}: {{$t('pairing.functionrfidlock')}}</option>
          </template>
        </SelectWithLabelIcon>
      </div>
      <div v-if="addpairuser!='-1'" class="form-group mb-4">
        <InputLabelError v-model="usertable.find(user => user.userId === addpairuser).name"
          :label="$t('pairing.rfiduser')" :placeholder="$t('pairing.rfiduserph')" :disabled="true" />
      </div>
      <div v-else class="form-group mb-4">
      </div>

      <div class="form-group mb-4 sm:mb-0">
        <InputLabelError v-model="addpairname" :label="$t('pairing.rfidname')" :placeholder="$t('pairing.rfidname')" />
      </div>
      <div class="form-group mb-4 sm:mb-0">
        <InputLabelError v-model="addpairtoken" :label="$t('pairing.rfidtoken')"
          :placeholder="$t('pairing.rfidtoken')" />
      </div>

      <div v-if="this.$store.state.Mesh&&addpairuser=='-1'" class="form-group mb-4 sm:mb-0">
        <SelectWithLabelIcon v-model="addpairclientgroup" :label="$t('pairing.rfidassign')"
          :placeholder="$t('pairing.rfidassign')" icon="IconAddRfid">
          <template v-slot:options>
            <option v-for="(gb, index) in groupclienttable.slice(1)" :key="index" :value="gb.value">
              {{gb.name}}
            </option>
          </template>
        </SelectWithLabelIcon>
      </div>

      <div class="form-group mb-4 sm:mb-0 sm:col-span-2">
        <label class="font-medium text-sm text-skin-b-list-mute" for="cardcolor">{{ $t('pairing.rfidcolor') }}</label>

        <div class="w-full flex flex-wrap">
          <div v-for="(farbe, index) in clut" :key="farbe" class="inline-flex p-1">
            <button @click="addpaircolor=farbe" :style="{ 'background-color': farbe}"
              class="px-4 py-1 h-10 font-semibold w-full rounded-full border-4 border-skin-b-list-bord focus:outline-none"
              :class="{'w-full': addpaircolor.toUpperCase()!==farbe, 
                'text-skin-b-invt cursor-default': addpaircolor.toUpperCase()===farbe}">
              <IconCheck v-if="addpaircolor.toUpperCase()==farbe" class="inline-flex -ml-2 mr-1 -mt-0.5 w-5 h-5" />
              <span class="inline-flex" v-if="addpaircolor.toUpperCase()==farbe">{{ clutname[index] }}</span>
            </button>
          </div>
        </div>

      </div>

    </div>

  </v-tailwind-modal>
  <!-- Edit Modal -->
  <v-tailwind-modal v-model="edit_modalshow" @confirm="save_edit" @cancel="cancel">
    <template v-slot:title>{{ $t('pairing.editrfid') }}</template>
    <template v-slot:icon>
      <IconEdit class="text-skin-b-list-mute" />
    </template>
    <div class="w-full sm:grid sm:gap-4 sm:grid-cols-2">
      <div class="form-group mb-4">

        <SelectWithLabelIcon v-model="cardtype_modal" :label="$t('pairing.rfidtype')"
          :placeholder="$t('pairing.rfidassign')" icon="IconStacks">
          <template v-slot:options>
            <option value="rfid" selected>{{$t('pairing.chargerfid')}}</option>
            <!--<option value="rfid_user">Benutzer-Ladekarte</option>-->
            <!--<option value="rfid_checkin">Ladekarte für easyCheckIn</option>-->
            <!--<option value="rfid_local">Ladekarte ohne OCPP-Funktion</option>-->
            <option value="fc_rfid_pair">{{$t('pairing.functionrfid')}}: {{$t('pairing.functionrfidlearn')}}</option>
            <option value="fc_rfid_charge">{{$t('pairing.functionrfid')}}: {{$t('pairing.functionrfidsolar')}}</option>
            <option value="fc_rfid_lock">{{$t('pairing.functionrfid')}}: {{$t('pairing.functionrfidlock')}}</option>
          </template>
        </SelectWithLabelIcon>
      </div>
      <div v-if="usertable.length > 0&&tabslist[0].view" class="form-group mb-4">
        <SelectWithLabelIcon v-model="carduser_modal" :label="$t('pairing.rfiduser')"
          :placeholder="$t('pairing.rfiduserph')">
          <template v-slot:options>
            <option value="" selected>{{$t('pairing.rfidusernot')}}</option>
            <option v-for="(user, index) in usertable" :key="index" :value="user.userId">
              <span v-if="user.alias!=''">{{user.alias}} - </span>{{user.name}}
            </option>
          </template>
        </SelectWithLabelIcon>
      </div>
      <div v-else class="form-group mb-4">
      </div>
      <div class="form-group mb-4">
        <InputLabelError v-model="cardname_modal" :label="$t('pairing.rfidname')"
          :placeholder="$t('pairing.rfidname')" />

        <label class="font-medium text-sm text-skin-b-list-mute" for="cardstatus">{{ $t('pairing.rfidstatus') }}</label>
        <div class="flex">
          <input v-if="cardstatus_modal=='active'" disabled type="text" class="form-control
                block px-3 py-2 rounded-l-lg w-full grow
                font-semibold text-lg
                border-2 border-skin-b-list-bord
                disabled:text-green-800 disabled:bg-green-100
                " ref="cardstatus" id="cardstatus" aria-describedby="cardstatus" placeholder="Status"
            :value="$t('pairing.active')">

          <input v-if="cardstatus_modal=='disabled'" disabled type="text" class="form-control
                block px-3 py-2 rounded-l-lg w-full grow
                font-semibold text-lg
                border-2 border-skin-b-list-bord
                disabled:text-red-800 disabled:bg-red-100
                " ref="cardstatus" id="cardstatus" aria-describedby="cardstatus" placeholder="Status"
            :value="$t('pairing.deactive')">
          <button v-if="cardstatus_modal=='active'" @click="cardstatus_modal='disabled'" type="button" class="inline-flex items-center px-3 py-2 font-semibold text-lg
          text-skin-b-list-base bg-skin-b-list-back border-r-2 border-y-2 border-skin-b-list-bord rounded-r-lg
          hover:text-red-800 hover:bg-red-100  
          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
            <IconBlock class="w-7 h-7" />
          </button>
          <button v-if="cardstatus_modal=='disabled'" @click="cardstatus_modal='active'" type="button" class="inline-flex items-center px-3 py-2 font-semibold text-lg
          text-skin-b-list-base bg-skin-b-list-back border-r-2 border-y-2 border-skin-b-list-bord rounded-r-lg
          hover:text-green-800 hover:bg-green-100  
          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
            <IconCheck class="w-7 h-7" />
          </button>
        </div>
      </div>
      <div class="form-group mb-4">

        <InputLabelError disabled v-model="cardtoken_modal" :label="$t('pairing.rfidtoken')"
          :placeholder="$t('pairing.rfidtoken')" />
        <InputLabelError disabled v-model="cardcreation_modal" :label="$t('pairing.rfidinit')"
          :placeholder="$t('pairing.rfidinit')" />
      </div>

      <div class="form-group mb-4 sm:col-span-2">
        <label class="font-medium text-sm text-skin-b-list-mute" for="renamecard">{{ $t('pairing.rfidcolor') }}</label>

        <div class="w-full flex flex-wrap">
          <div v-for="(farbe, index) in clut" :key="farbe" class="inline-flex p-1">
            <button @click="cardcolor_modal=farbe" :style="{ 'background-color': farbe}"
              class="px-4 py-1 h-10 font-semibold w-full rounded-full border-4 border-skin-b-list-bord focus:outline-none"
              :class="{'w-full': cardcolor_modal.toUpperCase()!==farbe, 
                'text-skin-b-invt cursor-default': cardcolor_modal.toUpperCase()===farbe}">
              <IconCheck v-if="cardcolor_modal.toUpperCase()==farbe" class="inline-flex -ml-2 mr-1 -mt-0.5 w-5 h-5" />
              <span class="inline-flex" v-if="cardcolor_modal.toUpperCase()==farbe">{{ clutname[index] }}</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </v-tailwind-modal>
  <!-- Share Modal -->
  <v-card-pair-modal v-model="pair_modalshow" @confirm="pair_confirm" @cancel="cancel">
    <template v-slot:title>'{{ cardname_modal }}' {{ $t('pairing.freelock') }}</template>
    <template v-slot:icon>
      <IconShare class="text-skin-b-list-mute" />
    </template>
    <div class="w-full sm:grid sm:gap-4 sm:grid-cols-2">

      <div class="form-group -m-4 sm:col-span-2 border-b border-skin-b-list-bord">

        <div class="md:flex md:flex-row md:px-4 md:py-4">

          <div class="md:flex-none md:w-96 md:mr-4">
            <SelectWithLabelIcon v-model="cardtoken_modal"
              @change="this.pairsaved=false;cardname_modal=this.allrfidtable[this.allrfidtable.findIndex(rfid => rfid.token === cardtoken_modal)].info;reload_pair(cardtoken_modal)"
              :placeholder="$t('pairing.rfidassign')">
              <template v-slot:options>
                <option v-for="(rfid, index) in allrfidtable" :key="index" :value="rfid.token">
                  {{rfid.info}}
                </option>
              </template>
            </SelectWithLabelIcon>
          </div>
          <div class="md:grow mt-2 md:mt-0">
          </div>
          <div class="mt-2 md:mt-0 md:ml-4">
            <button v-if="!pairsaved" @click="savepairings(cardtoken_modal)" :disabled="!pairchanged||allcheckcount==0"
              class="inline-block px-4 py-2 h-12
              rounded-lg border-2 border-transparent
              font-semibold text-lg text-skin-b-invt 
              bg-red-500
              disabled:opacity-50 disabled:bg-skin-active128 disabled:hover:bg-skin-active128 
              hover:bg-red-600
              focus:bg-red-500 focus:outline-none focus:ring-0 
              active:bg-red-500 
              transition duration-300 ease-in-out">
              {{ $t('common.savechanges') }}
            </button>
            <button v-if="pairsaved" disabled class="inline-block px-4 py-2 h-12
              rounded-lg border-2 border-transparent
              font-semibold text-lg text-skin-b-invt 
              bg-green-500
              disabled:bg-green-500">
              {{ $t('common.changessaved') }}
            </button>
          </div>
        </div>
      </div>
      <div class="form-group my-4 sm:col-span-2">
        <ShareGroupButton v-if="this.allcheckcount!=this.clienttable.length"
          @click="pairchanged=true;pairsaved=false;addpairtoall();" hovercolor="green">
          <IconRadioUnchecked class="w-7 h-7 mr-3" />
          {{ $t('pairing.allboxesonmesh') }}
        </ShareGroupButton>
        <ShareGroupButton v-if="this.allcheckcount==this.clienttable.length"
          @click="pairchanged=true;pairsaved=false;removepairfromall();" hovercolor="red">
          <IconRadioChecked class="w-7 h-7 mr-3" />
          {{ $t('pairing.allboxesonmesh') }}
        </ShareGroupButton>
        <div class="my-4" v-for="(group) in lvrfidgroupclient" :key="group.groupId">
          <div class="flex items-end">
            <ShareGroupButton v-if="group.checkcount<group.group.length"
              @click="pairchanged=true;pairsaved=false;addpairtogroup(group.groupId);" hovercolor="green">
              <IconRadioUnchecked class="w-7 h-7 mr-3" />
              {{ $t('pairing.group') }}: {{ group.name }}
            </ShareGroupButton>
            <ShareGroupButton v-if="group.checkcount==group.group.length"
              @click="pairchanged=true;pairsaved=false;removepairfromgroup(group.groupId);" hovercolor="red">
              <IconRadioChecked class="w-7 h-7 mr-3" />
              {{ $t('pairing.group') }}: {{ group.name }}
            </ShareGroupButton>
          </div>
          <div class="mx-5 md:mx-20" v-for="(box) in group.group" :key="box.id">
            <ShareBoxButton v-if="!box.boxcheck"
              @click="pairchanged=true;pairsaved=false;addpairtoclient(group.groupId,box.id);" hovercolor="green">
              <IconRadioUnchecked class="w-7 h-7 mr-3" />
              {{ box.name }}
            </ShareBoxButton>
            <ShareBoxButton v-if="box.boxcheck"
              @click="pairchanged=true;pairsaved=false;removepairfromclient(group.groupId,box.id);"
              hovercolor="red">
              <IconRadioChecked class="w-7 h-7 mr-3" />
              {{ box.name }}
            </ShareBoxButton>
          </div>

        </div>
      </div>
    </div>

  </v-card-pair-modal>
  <!-- Share User Modal -->
  <v-card-pair-modal v-model="userauth_modalshow" @confirm="userauth_confirm" @cancel="cancel">
    <template v-slot:title>'{{ user_name }}' {{ $t('pairing.freelock') }}</template>
    <template v-slot:icon>
      <IconShare class="text-skin-b-list-mute" />
    </template>
    <div class="w-full sm:grid sm:gap-4 sm:grid-cols-2">

      <div class="form-group -m-4 sm:col-span-2 border-b border-skin-b-list-bord">

        <div class="md:flex md:flex-row md:px-4 md:py-4">

          <div class="md:flex-none md:w-96 md:mr-4">
            <SelectWithLabelIcon v-model="user_id"
              @change="user_name=this.usertable[this.usertable.findIndex(user => user.userId === user_id)].name;reload_userauth(user_id)"
              :placeholder="$t('pairing.rfidassign')">
              <template v-slot:options>
                <option v-for="(user, index) in usertable" :key="index" :value="user.userId">
                  {{user.name}}
                </option>
              </template>
            </SelectWithLabelIcon>
          </div>
          <div class="md:grow mt-2 md:mt-0">
          </div>
          <div class="mt-2 md:mt-0 md:ml-4">
            <button v-if="!usersaved" @click="saveuserpairings(user_id)" :disabled="!userchanged||allcheckcount==0"
              class="inline-block px-4 py-2 h-12
              rounded-lg border-2 border-transparent
              font-semibold text-lg text-skin-b-invt 
              bg-red-500
              disabled:opacity-50 disabled:bg-skin-active128 disabled:hover:bg-skin-active128 
              hover:bg-red-600
              focus:bg-red-500 focus:outline-none focus:ring-0 
              active:bg-red-500 
              transition duration-300 ease-in-out">
              {{ $t('common.savechanges') }}
            </button>
            <button v-if="usersaved" disabled class="inline-block px-4 py-2 h-12
              rounded-lg border-2 border-transparent
              font-semibold text-lg text-skin-b-invt 
              bg-green-500
              disabled:bg-green-500">
              {{ $t('common.changessaved') }}
            </button>
          </div>
        </div>
      </div>
      <div class="form-group my-4 sm:col-span-2">
        <ShareGroupButton v-if="this.allcheckcount!=this.clienttable.length"
          @click="userchanged=true;usersaved=false;addusertoall();" hovercolor="green">
          <IconRadioUnchecked class="w-7 h-7 mr-3" />
          {{ $t('pairing.allboxesonmesh') }}
        </ShareGroupButton>
        <ShareGroupButton v-if="this.allcheckcount==this.clienttable.length"
          @click="userchanged=true;usersaved=false;removeuserfromall();" hovercolor="red">
          <IconRadioChecked class="w-7 h-7 mr-3" />
          {{ $t('pairing.allboxesonmesh') }}
        </ShareGroupButton>
        <div class="my-4" v-for="(group) in lvusergroupclient" :key="group.groupId">
          <div class="flex items-end">
            <ShareGroupButton v-if="group.checkcount<group.group.length"
              @click="userchanged=true;usersaved=false;addusertogroup(group.groupId);" hovercolor="green">
              <IconRadioUnchecked class="w-7 h-7 mr-3" />
              {{ $t('pairing.group') }}: {{ group.name }}
            </ShareGroupButton>
            <ShareGroupButton v-if="group.checkcount==group.group.length"
              @click="userchanged=true;usersaved=false;removeuserfromgroup(group.groupId);" hovercolor="red">
              <IconRadioChecked class="w-7 h-7 mr-3" />
              {{ $t('pairing.group') }}: {{ group.name }}
            </ShareGroupButton>
          </div>
          <div class="mx-5 md:mx-20" v-for="(box) in group.group" :key="box.id">
            <ShareBoxButton v-if="!box.boxcheck"
              @click="userchanged=true;usersaved=false;addusertoclient(group.groupId,box.id);" hovercolor="green">
              <IconRadioUnchecked class="w-7 h-7 mr-3" />
              {{ box.name }}
            </ShareBoxButton>
            <ShareBoxButton v-if="box.boxcheck"
              @click="userchanged=true;usersaved=false;removeuserfromclient(group.groupId,box.id);"
              hovercolor="red">
              <IconRadioChecked class="w-7 h-7 mr-3" />
              {{ box.name }}
            </ShareBoxButton>
          </div>
          
        </div>
      </div>
    </div>

  </v-card-pair-modal>
  <!-- User Modal -->
  <v-tailwind-modal v-model="user_modalshow" @confirm="save_user" @cancel="cancel">
    <template v-slot:title>{{ user_id=='-1' ? $t('pairing.adduser') : $t('pairing.edituser') }}</template>
    <template v-slot:icon>
      <IconEdit class="text-skin-b-list-mute" />
    </template>
    <div class="w-full sm:grid sm:gap-4 sm:grid-cols-2">

      <div class="form-group">
        <InputLabelError v-model="user_name" :label="$t('pairing.usernaming')"
          :placeholder="$t('pairing.usernaming')" />
      </div>
      <div class="form-group">
        <InputLabelError v-model="user_alias" :label="$t('pairing.useralias')" :placeholder="$t('pairing.useralias')" />
      </div>
      <div class="form-group">
        <InputLabelError v-model="user_email" :label="$t('pairing.useremail')" :placeholder="$t('pairing.useremail')" />
      </div>
      <!--
      <div class="form-group">
        <InputLabelError v-model="user_address" :label="$t('pairing.useradress')"
          :placeholder="$t('pairing.useradress')" />
      </div>-->
      <div class="form-group">
        <InputLabelError v-model="user_reference" :label="$t('pairing.userref')" :placeholder="$t('pairing.userref')" />
      </div>

      <div class="form-group">
        <label class="font-medium text-sm text-skin-b-list-mute" for="cardstatus">{{ $t('pairing.userstatus') }}</label>
        <div class="flex">
            <input
              disabled
              type="text"
              class="form-control block px-3 py-2 rounded-l-lg w-full grow font-semibold text-lg border-2 border-skin-b-list-bord"
              :class="user_status === 'active' 
                  ? 'disabled:text-green-800 disabled:bg-green-100'
                  : 'disabled:text-red-800 disabled:bg-red-100'"
              :value="user_status === 'active' ? $t('pairing.active') : $t('pairing.deactive')"
            />

          <button v-if="user_status=='active'" @click="user_status='disabled'" type="button" class="inline-flex items-center px-3 py-2 font-semibold text-lg
            text-skin-b-list-base bg-skin-b-list-back border-r-2 border-y-2 border-skin-b-list-bord rounded-r-lg
            hover:text-red-800 hover:bg-red-100  
            focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
            <IconBlock class="w-7 h-7" />
          </button>
          <button v-if="user_status=='disabled'" @click="user_status='active'" type="button" class="inline-flex items-center px-3 py-2 font-semibold text-lg
            text-skin-b-list-base bg-skin-b-list-back border-r-2 border-y-2 border-skin-b-list-bord rounded-r-lg
            hover:text-green-800 hover:bg-green-100  
            focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
            <IconCheck class="w-7 h-7" />
          </button>
          
        </div>
      </div>

      <!--
      <div class="form-group">
        <InputLabelError v-model="user_info" :label="$t('pairing.userinfo')" :placeholder="$t('pairing.userinfo')" />
      </div>-->

      <div v-if="user_creationoffset!=''" class="form-group">
        <InputLabelError disabled v-model="user_creationoffset" :label="$t('pairing.usercreation')"
          :placeholder="$t('pairing.usercreation')" />
      </div>

    </div>
  </v-tailwind-modal>

  <CounterModal v-if="newrfidmodal">
    <template #counter>
      {{ rfidcounter }} s
    </template>
    <template #text>
      {{ $t('pairing.learnrfidtxt') }}
    </template>
  </CounterModal>

  <SrcBackground>
    <HeadlineSub :title="$t('menu.pairings')" target="/Main" settarget="/SetMesh" :hassetting=true :hassubline=false :hasmenu=true>
      <template #icon>
        <IconPersonCircle v-if="activeTab=='users'" class="w-12 h-12" />
        <IconRfidCar v-if="activeTab=='charge'" class="w-12 h-12" />
        <IconFunction v-if="activeTab=='function'" class="w-12 h-12" />
      </template>
      <template #menu>
        <TabsNav :tabs="tabslist" v-model="activeTab" />
      </template>
    </HeadlineSub>

    <!--<div class="px-4 my-6 max-w-5xl">-->
    <div class="px-2 sm:px-4 w-full max-w-5xl fixed top-20 sm:top-24 flex flex-col h-full">
      <!--Tabellenkopf-->
      <div :class="[ editmode.status || editusermode.status ? 'bg-skin-active128/5' : 'bg-skin-b-list-head' ]"
        class="flex items-center mx-0 mt-4 sm:mt-6 border-2 border-skin-b-list-bord rounded-t-xl">
        <!-- Linker Bereich: Buttons -->
        <div class="flex items-center md:w-auto">
          <ButtonHeaderIcon v-if="selectedtab!='users'&&editmode.status&&(filteredPairings.length!=editcount)"
            @click="MarkToEditAll(true,false);" class="" :options="[]">
            <IconRadioChecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="selectedtab=='users'&&editusermode.status&&(filteredUsers.length!=editusercount)"
            @click="MarkToEditAll(true,true);" class="" :options="[]">
            <IconRadioChecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="selectedtab!='users'&&editmode.status&&(filteredPairings.length==editcount)"
            @click="MarkToEditAll(false,false);" class="" :options="[]">
            <IconRadioUnchecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="selectedtab=='users'&&editusermode.status&&(filteredUsers.length==editusercount)"
            @click="MarkToEditAll(false,true);" class="" :options="[]">
            <IconRadioUnchecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="!editmode.status&&activeTab!='users'" tooltipText="" tooltipPosition="top-left"
            :options="
                  [
                    { label: $t('pairing.addrfid'), icon: 'IconAddRfid', show: true, 
                      action: () => { addpairuser='-1';addpair_modalshow=true; }
                    },
                    { label: $t('pairing.addrfidto', { name: getClientName('b'+this.$store.state.WbLogId) } ), icon: 'IconLearnRfid', show: true,
                      action: () => { addnewrfid(this.$store.state.WbLogId); }
                    },
                    { label: $t('pairing.addrfidto', { name: getClientName('b'+this.$store.state.WbId) } ), icon: 'IconLearnRfid' ,show: this.$store.state.WbLogId != this.$store.state.WbId,
                      action: () => { addnewrfid(this.$store.state.WbId); }
                    },
                  ]">
            <!--<IconAddRfid class="w-12 h-12"/>-->
            <IconAdd class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="!editusermode.status&&activeTab=='users'" @click="user_id='-1';
                        user_name='';
                        user_alias='';
                        user_email='';
                        user_address='';
                        user_status='active';
                        user_reference='';
                        user_info='';
                        user_creationoffset='';
                        user_modalshow=true;" class="" :options="[]">
            <IconAdd class="w-10 h-10" />
          </ButtonHeaderIcon>

        </div>
        <!-- Mittlerer Bereich: Hauptbedienelemente -->
        <div class="flex-grow flex flex-col items-center w-full">
          <!-- Mittlerer Bereich: obere Zeile -->
          <div class="flex items-center border-b-2 w-full"
            :class="[editmode.status || editusermode.status ? 'justify-between' : 'justify-stretch']">
            <!-- 'ALLE AUSWÄHLEN' -->
            <ButtonHeader v-if="selectedtab!='users'&&editmode.status&&(filteredPairings.length!=editcount)"
              @click="MarkToEditAll(true,false);">
              <span class="sm:hidden">{{ $t('common.selectallmin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectall') }}</span>
            </ButtonHeader>
            <ButtonHeader v-if="selectedtab=='users'&&editusermode.status&&(filteredUsers.length!=editusercount)"
              @click="MarkToEditAll(true,true);">
              <span class="sm:hidden">{{ $t('common.selectallmin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectall') }}</span>
            </ButtonHeader>
            <!-- 'KEINE AUSWÄHLEN' -->
            <ButtonHeader v-if="selectedtab!='users'&&editmode.status&&(filteredPairings.length==editcount)"
              @click="MarkToEditAll(false,false);">
              <span class="sm:hidden">{{ $t('common.selectnonemin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectnone') }}</span>
            </ButtonHeader>
            <ButtonHeader v-if="selectedtab=='users'&&editusermode.status&&(filteredUsers.length==editusercount)"
              @click="MarkToEditAll(false,true);">
              <span class="sm:hidden">{{ $t('common.selectnonemin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectnone') }}</span>
            </ButtonHeader>
            <!-- 'Status XX ausgewählt' -->
            <span v-if="selectedtab!='users'&&editmode.status&&editcount>0"
              class="bg-black/5 text-skin-b-list-base text-base px-3 py-0.5 rounded-full">
              <strong>{{ editcount }}</strong>
              <span class="hidden sm:inline-block">&nbsp;{{ $t('common.selected') }}</span>
            </span>
            <span v-if="selectedtab=='users'&&editusermode.status&&editusercount>0"
              class="bg-black/5 text-skin-b-list-base text-base px-3 py-0.5 rounded-full">
              <strong>{{ editusercount }}</strong>
              <span class="hidden sm:inline-block">&nbsp;{{ $t('common.selected') }}</span>
            </span>
            <!-- 'ABBRRECHEN' -->
            <ButtonHeader v-if="selectedtab!='users'&&editmode.status"
              @click="editmode.status = !editmode.status;MarkToEditAll(false,false);">
              {{ $t('common.cancel') }}
            </ButtonHeader>
            <ButtonHeader v-if="selectedtab=='users'&&editusermode.status"
              @click="editusermode.status = !editusermode.status;MarkToEditAll(false,true);">
              {{ $t('common.cancel') }}
            </ButtonHeader>
            <!-- Selector Ladekartenarten -->
            <NavSelectWithIcon v-if="selectedtab === 'charge' && !editmode.status" v-model="rfidtype"
              @update:modelValue="filterpicker(this.filterboxid)" :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'charging_token', label: $t('pairing.filterallrfid'), icon: 'none', highlight: true, show: true },
                    { value: 'rfid', label: $t('pairing.filterloadrfid'), icon: 'none', highlight: false, show: typEasyCheckIn||typGroupUser||typNoOcpp },
                    { value: 'rfid_user', label: $t('pairing.filteruserrfid'), icon: 'none', highlight: false, show: typGroupUser },
                    { value: 'rfid_checkin', label: $t('pairing.filtercheckinrfid'), icon: 'none', highlight: false, show: typEasyCheckIn },
                    { value: 'rfid_local', label: $t('pairing.filterlocalrfid'), icon: 'none', highlight: false, show: typNoOcpp }
                  ]">
            </NavSelectWithIcon>
            <!-- Selector Funktionskartenarten -->
            <NavSelectWithIcon v-if="selectedtab === 'function' && !editmode.status" v-model="rfidtype"
              @update:modelValue="filterpicker(this.filterboxid)" :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'fc_rfid', label: $t('pairing.filterallfunction'), icon: 'none', highlight: true, show: true },
                    { value: 'fc_rfid_pair', label: $t('pairing.filterlearnfunction'), icon: 'none', highlight: false, show: true },
                    { value: 'fc_rfid_charge', label: $t('pairing.filtersolarfunction'), icon: 'none', highlight: false, show: true },
                    { value: 'fc_rfid_lock', label: $t('pairing.filterlockfunction'), icon: 'none', highlight: false, show: true }
                  ]">
            </NavSelectWithIcon>
            <!-- Selector Funktionskartenarten -->
            <NavSelectWithIcon v-if="this.$store.state.Mesh&&!editmode.status&&activeTab!='users'" v-model="filterboxid"
              @update:modelValue="filterpicker(this.filterboxid)" class="hidden sm:block"
              :placeholder="$t('common.pleaseselect')" :options="groupclienttable">
            </NavSelectWithIcon>
            <!-- 'BEARBEITEN' -->
            <ButtonHeader v-if="selectedtab!='users'&&filteredPairings.length>0&&!editmode.status"
              @click="editmode.status = !editmode.status;">
              <span>
                <IconRadioChecked class="sm:mr-1 w-6 h-6 sm:hidden" />
              </span>
              <span class="hidden sm:block">{{ $t('common.edit') }}</span>
            </ButtonHeader>
            <ButtonHeader v-if="selectedtab==='users'&&filteredUsers.length>0&&!editusermode.status"
              @click="editusermode.status = !editusermode.status;">
              <span>
                <IconRadioChecked class="sm:mr-1 w-6 h-6 sm:hidden" />
              </span>
              <span class="hidden sm:block">{{ $t('common.edit') }}</span>
            </ButtonHeader>
            <!-- 'EXPORT CSV' -->
            <ButtonHeader v-if="selectedtab!='users'&&filteredPairings.length>0&&!editmode.status"
              class="min-w-fit text-nowrap !important" @click="LoadingCSV()">
              <span>
                <IconDownload class="sm:mr-1 w-6 h-6" />
              </span>
              <span class="hidden sm:block">{{ $t('pairing.exportcsv') }}</span>
            </ButtonHeader>

          </div>
          <!-- Mittlerer Bereich: Untere Zeile -->
          <div class="w-full flex items-center justify-between">
            <!-- Mobile Sorting RFID -->
            <NavSelectWithIcon v-if="selectedtab!='users'&&!editmode.status" v-model="sortlist"
              class="w-full flex-shrink sm:hidden" @update:modelValue="filterpicker(this.filterboxid)"
              :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'nameup', label: $t('common.nameuppercase')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'namedown', label: $t('common.nameuppercase')+' ('+$t('common.descending')+')', icon: 'IconSortDown', show: true },
                    { value: 'dateup', label: $t('common.dateuppercase')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'datedown', label: $t('common.dateuppercase')+' ('+$t('common.descending')+')', icon: 'IconSortDown' ,show: true }
                  ]">
            </NavSelectWithIcon>
            <!-- Mobile Sorting User -->
            <NavSelectWithIcon v-if="selectedtab=='users'&&!editusermode.status" v-model="sortuserlist"
              class="w-full flex-shrink sm:hidden" @update:modelValue="reloadpage();"
              :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'nameup', label: $t('common.nameuppercase')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'namedown', label: $t('common.nameuppercase')+' ('+$t('common.descending')+')', icon: 'IconSortDown', show: true },
                    { value: 'dateup', label: $t('common.dateuppercase')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'datedown', label: $t('common.dateuppercase')+' ('+$t('common.descending')+')', icon: 'IconSortDown' ,show: true }
                  ]">
            </NavSelectWithIcon>
            <!-- Normal Sorting RFID -->
            <div v-if="selectedtab!='users'&&!editmode.status"
              class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
              <button
                @click="if(sortlist=='nameup') sortlist='namedown'; else sortlist='nameup';filterpicker(filterboxid);"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.name') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="sortlist=='nameup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="sortlist=='namedown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!sortlist.includes('name')" />
              </button>
              <button
                @click="if(sortlist=='dateup') sortlist='datedown'; else sortlist='dateup';filterpicker(filterboxid);"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.date') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="sortlist=='dateup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="sortlist=='datedown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!sortlist.includes('date')" />
              </button>
              <button @click="filterblocked=!filterblocked;filterpicker(filterboxid);"
                class="py-2 px-4 inline-flex text-skin-b-list-mute cursor-pointer focus:outline-none relative group uppercase">
                {{ $t('pairing.deactive') }}
                <IconRadioChecked class="ml-1 w-6 h-6" v-if="filterblocked" />
                <IconRadioUnchecked class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100" v-if="!filterblocked" />
              </button>

              <div class="hidden md:flex items-center w-48 text-skin-b-list-mute">
                <IconSearch v-if="searchfilter==''" @click="this.$refs.SearchFilterInput.focus();"
                  class="w-6 h-6 mr-1 hover:cursor-pointer flex-none" />
                <IconClose v-else
                  @click="searchfilter='';filterpicker(filterboxid);this.$refs.SearchFilterInput.focus();"
                  class="h-6 w-6 mr-1 hover:cursor-pointer flex-none" />
                <input class="shrink md:flex-1 w-full px-2 py-1 appearance-none 
                                  text-base leading-tight border-0 rounded
                                  bg-slate-300/20 focus:bg-slate-300/30
                                  focus:outline-none focus:ring-0"
                  :class="[ searchfilter=='' ? 'bg-slate-300/20 font-normal' : 'bg-slate-300/30 font-bold' ]"
                  type="text" ref="SearchFilterInput" :placeholder="$t('common.searchuppercase')" v-model="searchfilter"
                  @input="filterpicker(filterboxid);">
              </div>
            </div>
            <!-- Normal Sorting User -->
            <div v-if="selectedtab=='users'&&!editusermode.status"
              class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
              <button
                @click="if(sortuserlist=='nameup') sortuserlist='namedown'; else sortuserlist='nameup';reloadpage();"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.name') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="sortuserlist=='nameup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="sortuserlist=='namedown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!sortuserlist.includes('name')" />
              </button>
              <button
                @click="if(sortuserlist=='dateup') sortuserlist='datedown'; else sortuserlist='dateup';reloadpage();"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.date') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="sortuserlist=='dateup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="sortuserlist=='datedown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!sortuserlist.includes('date')" />
              </button>
              <button @click="filterblocked=!filterblocked;"
                class="py-2 px-4 inline-flex text-skin-b-list-mute cursor-pointer focus:outline-none relative group uppercase">
                {{ $t('pairing.deactive') }}
                <IconRadioChecked class="ml-1 w-6 h-6" v-if="filterblocked" />
                <IconRadioUnchecked class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100" v-if="!filterblocked" />
              </button>

              <div class="hidden md:flex items-center w-48 text-skin-b-list-mute">
                <IconSearch v-if="searchfilter==''" @click="this.$refs.SearchFilterInput.focus();"
                  class="w-6 h-6 mr-1 hover:cursor-pointer flex-none" />
                <IconClose v-else @click="searchfilter='';this.$refs.SearchFilterInput.focus();"
                  class="h-6 w-6 mr-1 hover:cursor-pointer flex-none" />
                <input class="shrink md:flex-1 w-full px-2 py-1 appearance-none 
                                  text-base leading-tight border-0 rounded
                                  bg-slate-300/20 focus:bg-slate-300/30
                                  focus:outline-none focus:ring-0"
                  :class="[ searchfilter=='' ? 'bg-slate-300/20 font-normal' : 'bg-slate-300/30 font-bold' ]"
                  type="text" ref="SearchFilterInput" :placeholder="$t('common.searchuppercase')"
                  v-model="searchfilter">
              </div>
            </div>

            <NavEditWithIcon v-if="selectedtab!='users'&&editmode.status&&editmode.tokenlist.length>0"
              v-model="multieditselector" class="w-full flex-shrink" :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'delete', label: $t('common.delete'), icon: 'delete', color:'red', show: true,
                      onClick: () => { deletemodal=true; }
                     },
                    { value: 'lock', label: $t('common.block'), icon: 'block', color:'red', show: true,
                      onClick: () => { switchstatus('multi','disabled'); }
                     },
                    { value: 'unlock', label: $t('common.activate'), icon: 'check', color:'green', show: true,
                      onClick: () => { switchstatus('multi','active'); }
                     },
                    { value: 'type', label: $t('common.changetype'), icon: 'stacks', show: true,
                      onClick: () => { multieditmodal=true; }
                     },
                    { value: 'user', label: $t('pairing.rfiduser'), icon: 'user', show: usertable.length > 0&&tabslist[0].view,
                      onClick: () => { carduser_modal=usertable[0].userId;multiusermodal=true; }
                     },
                    { value: 'color', label: $t('common.changecolor'), icon: 'color', show: true,
                      onClick: () => { multicolormodal=true; }
                     },
                  ]">
            </NavEditWithIcon>
            <NavEditWithIcon v-if="selectedtab=='users'&&editusermode.status&&editusermode.uidlist.length>0"
              v-model="multieditselector" class="w-full flex-shrink" :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'delete', label: $t('common.delete'), icon: 'delete', color:'red', show: true,
                      onClick: () => { deleteusermodal=true; }
                     },
                    { value: 'lock', label: $t('common.block'), icon: 'block', color:'red', show: true,
                      onClick: () => { switchuserstatus('multi','disabled'); }
                     },
                    { value: 'unlock', label: $t('common.activate'), icon: 'check', color:'green', show: true,
                      onClick: () => { switchuserstatus('multi','active'); }
                     },
                  ]">
            </NavEditWithIcon>
            <!--
                <div v-if="editmode.status&&editmode.tokenlist.length>0" class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
                  <ButtonHeader
                    @click="deletemodal=true;"
                  >
                    <span><IconDelete class="sm:mr-1 w-6 h-6"/></span>
                    <span class="hidden sm:block">{{ $t('common.delete') }}</span>
                  </ButtonHeader>
                </div>
                -->
            <div v-if="filteredPairings.length > 0 && selectedtab != 'users'" class="flex-auto my-auto text-right">
              <h4 class="py-2 px-4 text-skin-b-list-mute">
                <span><strong>{{ filteredPairings.length }}</strong>&nbsp;RFIDs</span>
              </h4>
            </div>
            <div v-if="filteredUsers.length > 0 && selectedtab == 'users'" class="flex-auto my-auto text-right">
              <h4 class="py-2 px-4 text-skin-b-list-mute">
                <span><strong>{{ filteredUsers.length }}</strong>&nbsp;{{$t('pairing.usernumber')}}</span>
              </h4>
            </div>
          </div>
        </div>

      </div>
      <!--Tabellenkopf Ende-->

      <ListDynamicDiv v-if="selectedtab=='users'">
        <ListBody :items="filteredUsers" itemKey="userId" :isLoading="isLoading" :users="true">
          <template #item="{ item }">
            <ListItemUser
              @listclick="editusermode.status && (item.checked = !item.checked, MarkToEdit(item.checked, item.userId, true))"
              :itemdata="item" @toggle-showmore="item.showmore = !item.showmore" :editmode="editusermode.status"
              :hoverButtons="[
                              { label: $t('common.delete'), show: true, icon: 'IconDelete', color: 'red',
                                onClick: () => { deleteuser=item;deleteusermodal=true; }
                              },
                              { label: $t('common.block'), show: item.status=='active', icon: 'IconBlock', color: 'red',
                                onClick: () => { switchuserstatus(item.userId,'disabled') }
                              },
                              { label: $t('common.activate'), show: item.status=='disabled', icon: 'IconCheck', color: 'green',
                                onClick: () => { switchuserstatus(item.userId,'active') }
                              },
                              { label: $t('common.assign'), show: this.$store.state.Mesh, icon: 'IconShare',
                                onClick: () => {  reload_userauth(item.userId);
                                                  user_id=item.userId;
                                                  user_name=item.name;
                                                  userauth_modalshow = true; }
                              },
                              { label: $t('common.edit'), show: true, icon: 'IconEdit',
                                onClick: () => {  user_id=item.userId;
                                                  user_name=item.name;
                                                  user_alias=item.alias;
                                                  user_email=item.email;
                                                  user_address=item.address;
                                                  user_status=item.status;
                                                  user_reference=item.reference;
                                                  user_info=item.info;
                                                  user_creationoffset=item.creationoffset;
                                                  user_modalshow = true; }
                              },
                                { label: $t('pairing.addrfid'), show: true, icon: 'IconAddRfid',
                                onClick: () => {  addpairuser=item.userId;
                                                  addpair_modalshow=true; }
                              
                              },
                  ]">
            </ListItemUser>
          </template>
        </ListBody>
      </ListDynamicDiv>

      <ListDynamicDiv v-else>
        <ListBody :items="filteredPairings" itemKey="id" :isLoading="isLoading">
          <template #item="{ item }">

            <ListItem
              @listclick="editmode.status && (item.checked = !item.checked, MarkToEdit(item.checked, item.token, false))"
              :itemdata="item" :editmode="editmode.status" :hoverButtons="[
                              { label: $t('common.delete'), show: true, icon: 'IconDelete', color: 'red',
                                onClick: () => { deletepairtoken=item.token;deletepairname=item.info;deletemodal=true; }
                              },
                              { label: $t('common.block'), show: item.status=='active', icon: 'IconBlock', color: 'red',
                                onClick: () => { switchstatus(item.token,'disabled') }
                              },
                              { label: $t('common.activate'), show: item.status=='disabled', icon: 'IconCheck', color: 'green',
                                onClick: () => { switchstatus(item.token,'active') }
                              },
                              { label: $t('common.assign'), show: this.$store.state.Mesh, icon: 'IconShare',
                                onClick: () => { reload_pair(item.token);
                                                  cardtoken_modal=item.token;
                                                  cardname_modal=item.info;
                                                  cardcolor_modal=item.color;
                                                  cardstatus_modal=item.status;
                                                  cardcreation_modal=item.creationoffset;
                                                  pair_modalshow = true; }
                              },
                              { label: $t('common.edit'), show: true, icon: 'IconEdit',
                                onClick: () => { cardtype_modal=item.typ;
                                                  carduser_modal = item.user//item.user=='' ? '-1' : item.user;
                                                  cardkey_modal=item.key;
                                                  cardtype_modal=item.typ;
                                                  cardtoken_modal=item.token;
                                                  cardname_modal=item.info;
                                                  cardcolor_modal=item.color;
                                                  cardstatus_modal=item.status;
                                                  cardcreation_modal=item.creationoffset;
                                                  edit_modalshow = true }
                              },
                  ]">
            </ListItem>

          </template>
        </ListBody>
      </ListDynamicDiv>
      <!-- Modal delete for marked users -->
      <MultiModal :show="deleteusermodal" @close="deleteusermodal=false">
        <template #header>
          <IconSpinner v-if="savewait" class="w-8 h-8 mr-2" />
          <IconError v-else class="w-8 h-8 mr-2" />
          {{ $t('common.delete') }}
        </template>
        <template v-if="!editusermode.status">
          <div class="text-lg font-semibold text-center">
            <div>{{ $t('pairing.deleteusera') }}</div>
            <div class="text-xl text-red-600 bg-red-100 px-2 py-1 rounded mx-auto my-2">
              <div class="text-xl text-red-600"><span v-if="deleteuser.alias!=''">{{ deleteuser.alias }} - </span>{{
                deleteuser.name }}</div>
              <div class="text-base text-red-600">
                <IconMail class="inline-block -mt-1 w-5 h-5" />
                {{ deleteuser.email }}
              </div>
            </div>
            <div>{{ $t('pairing.deleteb') }}</div>
          </div>
        </template>
        <template v-else>
          <div class="text-lg font-semibold text-center">
            <div>{{ $t('pairing.deletealla') }}</div>
            <div class="text-xl text-red-600 bg-red-100 px-2 py-1 rounded mx-auto my-2">
              {{ $t('pairing.deleteallusersb', {count: editusermode.uidlist.length} ) }}
            </div>
            <div>{{ $t('pairing.deleteb') }}</div>
          </div>
        </template>
        <template v-if="!editusermode.status" #footer>
          <BlueButton @click="deleteusermodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="savewait=true;this.deleteoneuser(deleteuser.userId)">
            {{ $t('common.yesdelete') }}
          </RedButton>          
        </template>
        <template v-else #footer>
          <BlueButton @click="deleteusermodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="savewait=true;this.deletemarkedusers(editusermode.uidlist)">
            {{ $t('common.yesdelete') }}
          </RedButton>          
        </template>
      </MultiModal>
      <!-- Modal delete for marked RFIDs -->
      <MultiModal :show="deletemodal" @close="deletemodal=false">
        <template #header>
          <IconError class="w-8 h-8 mr-2" />
          {{ $t('common.delete') }}
        </template>
        <template v-if="!editmode.status">
          <div class="text-lg font-semibold text-center">
            <div>{{ $t('pairing.deletea') }}</div>
            <div class="text-xl text-red-600 bg-red-100 px-2 py-1 rounded mx-auto my-2">
              <div class="text-xl text-red-600">{{ deletepairname }}</div>
              <div class="text-base text-red-600">
                <IconRfidToken class="inline-block -mt-1 w-5 h-5" />
                {{ deletepairtoken }}
              </div>
            </div>
            <div>{{ $t('pairing.deleteb') }}</div>
          </div>
        </template>
        <template v-else>
          <div class="text-lg font-semibold text-center">
            <div>{{ $t('pairing.deletealla') }}</div>
            <div class="text-xl text-red-600 bg-red-100 px-2 py-1 rounded mx-auto my-2">
              {{ $t('pairing.deleteallb', {count: editmode.tokenlist.length} ) }}
            </div>
            <div>{{ $t('pairing.deleteb') }}</div>
          </div>
        </template>
        <template v-if="!editmode.status" #footer>
          <BlueButton @click="deletemodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="this.deletepair(deletepairtoken)">
            {{ $t('common.yesdelete') }}
          </RedButton>          
        </template>
        <template v-else #footer>
          <BlueButton @click="deletemodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="this.deletemarkedpairs(editmode.tokenlist)">
            {{ $t('common.yesdelete') }}
          </RedButton>          
        </template>
      </MultiModal>
      <!-- Modal change type for marked RFIDs -->
      <MultiModal :show="multieditmodal" @close="multieditmodal=false">
        <template #header>
          {{ $t('pairing.changepairingtype', {count: editmode.tokenlist.length} ) }}
        </template>
        <div class="space-y-2">
          <div v-for="option in rfidtypeoptions" :key="option.value" class="flex items-center space-x-2">
            <div @click="changerfidtype=option.value" class="cursor-pointer mr-2" :class="[
                    changerfidtype === option.value ? 'text-skin-b-list-base' : 'text-gray-500'
                    ]">
              <IconRadioChecked v-if="changerfidtype === option.value" class="w-7 h-7" />
              <IconRadioUnchecked v-else class="w-7 h-7" />
            </div>
            <label :for="option.value" class="text-base cursor-pointer" :class="[
                changerfidtype === option.value ? 'font-semibold text-skin-b-list-base' : 'text-gray-500'
                ]" @click="changerfidtype=option.value">
              {{ option.label }}
            </label>
          </div>
        </div>
        <template #footer>
          <BlueButton @click="multieditmodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="this.changepairingtype(changerfidtype)">
            {{ $t('common.change') }}
          </RedButton>          
        </template>
      </MultiModal>
      <!-- Modal change user for marked RFIDs -->
      <MultiModal :show="multiusermodal" @close="multiusermodal=false">
        <template #header>
          {{ $t('pairing.changepairinguser', {count: editmode.tokenlist.length} ) }}
        </template>
        <SelectWithLabelIcon v-model="carduser_modal" :placeholder="$t('pairing.rfiduserph')">
          <template v-slot:options>
            <option v-for="(user, index) in usertable" :key="index" :value="user.userId">
              <span v-if="user.alias!=''">{{user.alias}} - </span>{{user.name}}
            </option>
          </template>
        </SelectWithLabelIcon>
        <template #footer>
          <BlueButton @click="multiusermodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="this.changepairinguser(carduser_modal)">
            {{ $t('common.change') }}
          </RedButton>          
        </template>
      </MultiModal>
      <!-- Modal change color for marked RFIDs -->
      <MultiModal :show="multicolormodal" @close="multicolormodal=false">
        <template #header>
          {{ $t('pairing.changepairingcolor', {count: editmode.tokenlist.length} ) }}
        </template>
        <div class="w-full flex flex-wrap">
          <div v-for="(farbe, index) in clut" :key="farbe" class="inline-flex p-1">
            <button @click="multicolorcode=farbe" :style="{ 'background-color': farbe}"
              class="px-4 py-1 h-10 font-semibold w-full rounded-full border-4 border-skin-b-list-bord focus:outline-none"
              :class="{'w-full': multicolorcode.toUpperCase()!==farbe, 
              'text-skin-b-invt cursor-default': multicolorcode.toUpperCase()===farbe}">
              <IconCheck v-if="multicolorcode.toUpperCase()==farbe" class="inline-flex -ml-2 mr-1 -mt-0.5 w-5 h-5" />
              <span class="inline-flex" v-if="multicolorcode.toUpperCase()==farbe">{{ clutname[index] }}</span>
            </button>
          </div>
        </div>
        <template #footer>
          <BlueButton @click="multicolormodal=false">
            {{ $t('common.cancel') }}
          </BlueButton>
          <RedButton @click="this.changepairingcolor(multicolorcode)">
            {{ $t('common.change') }}
          </RedButton>          
        </template>
      </MultiModal>

    </div>


  </SrcBackground>
</template>

<script>
import { useI18n } from 'vue-i18n'
import IconAdd from './icons/IconAdd.vue'
import IconEdit from './icons/IconEdit.vue'
import IconShare from './icons/IconShare.vue'
import IconError from './icons/IconError.vue'
import IconPersonCircle from './icons/IconPersonCircle.vue'
import IconFunction from './icons/IconFunction.vue'
import IconAddRfid from './icons/IconAddRfid.vue'
import IconDownload from './icons/IconDownload.vue'
import IconRfidCar from './icons/IconRfidCar.vue'
import IconRfidToken from './icons/IconRfidToken.vue'
import IconCheck from './icons/IconCheck.vue'
import IconClose from './icons/IconClose.vue'
import IconSearch from './icons/IconSearch.vue'
import IconBlock from './icons/IconBlock.vue'
import IconSort from './icons/IconSort.vue'
import IconSortUp from './icons/IconSortUp.vue'
import IconSortDown from './icons/IconSortDown.vue'
import IconRadioChecked from './icons/IconRadioChecked.vue'
import IconRadioUnchecked from './icons/IconRadioUnchecked.vue'
import IconSpinner from './icons/IconSpinner.vue'
import BlueButton from './sources/SrcBlueButton.vue'
import RedButton from './sources/SrcRedButton.vue'
import SrcBackground from './sources/SrcBackground.vue'
import HeadlineSub from './elements/HeadlineSub.vue'
import ListDynamicDiv from './elements/ListDynamicDiv.vue'
import ListBody from './elements/ListBody.vue'
import ListItem from './elements/ListItem.vue'
import ListItemUser from './elements/ListItemUser.vue'
import CounterModal from './elements/CounterModal.vue'
import MultiModal from './elements/MultiModal.vue'
import InputLabelError from './elements/InputLabelError.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import NavSelectWithIcon from './elements/NavSelectWithIcon.vue'
import NavEditWithIcon from './elements/NavEditWithIcon.vue'
import ButtonHeader from './elements/ButtonHeaderTooltip.vue'
import ButtonHeaderIcon from './elements/ButtonHeaderIconTooltip.vue'
import TabsNav from './elements/TabsNav.vue'
import ShareGroupButton from './elements/ShareGroupButton.vue'
import ShareBoxButton from './elements/ShareBoxButton.vue'
import IconMail from './icons/IconMail.vue'

const LOCAL_FILTER_ID = '-3';
const MESH_FILTER_ID = '-2';
const ALL_FILTER_ID = '-1';
const TOKEN_EXPIRED = 'token';
const RESPONSE_OK = 'ok';
const NO_CONNECTION_STATUS = 'no_connection';

function generateAlias(fullName) {
  if (!fullName) return ''

  const parts = fullName
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  if (parts.length === 0) return ''

  const first = parts[0][0] || ''
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''

  return (first + last).toUpperCase().slice(0, 2)
}

export default {
  name: 'CardssPage',
  components: {
    IconAdd, IconEdit, IconShare, IconError, IconFunction, IconPersonCircle,
    IconRfidCar, IconMail,
    IconClose, IconSearch, IconSpinner,
    IconAddRfid, IconDownload, IconRfidToken,
    IconCheck, IconBlock, IconSort, IconSortUp, IconSortDown, IconRadioChecked, IconRadioUnchecked,
    SrcBackground, HeadlineSub,
    ListDynamicDiv, ListBody, ListItem, ListItemUser,
    CounterModal, MultiModal,
    ButtonHeaderIcon, ButtonHeader, BlueButton, RedButton, InputLabelError, SelectWithLabelIcon, NavSelectWithIcon, NavEditWithIcon,
    TabsNav, ShareGroupButton, ShareBoxButton
  },
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  },
  data() {
    return {
      polling: true,
      decodeEl: null,
      tabslist: [
        {
          name: 'Nutzer',
          value: 'users',
          view: false, //users an/aus
          onClick: () => {
            this.selectedtab = 'users'; this.$store.commit('setCardsTab', 'users'); 
            this.rfidtype = 'rfid_user'; this.$store.commit('setCardsType', 'rfid_user');
            this.editmode = { status: false, tokenlist: [] };this.editusermode = { status: false, uidlist: [] };
            this.searchfilter = '';
            this.filterboxid = MESH_FILTER_ID; this.reloadpage();//this.filterpicker(this.filterboxid);
          },
        },
        {
          name: this.$t('pairing.chargerfids'),
          value: 'charge',
          view: true,
          onClick: () => {
            this.selectedtab = 'charge'; this.$store.commit('setCardsTab', 'charge'); 
            this.rfidtype = 'charging_token'; this.$store.commit('setCardsType', 'charging_token'); 
            this.editmode = { status: false, tokenlist: [] };this.editusermode = { status: false, uidlist: [] };
            this.searchfilter = '';
            this.filterboxid = MESH_FILTER_ID; this.filterpicker(this.filterboxid);
          },
        },
        {
          name: this.$t('pairing.functionrfids'),
          value: 'function',
          view: true,
          onClick: () => {
            this.selectedtab = 'function'; this.$store.commit('setCardsTab', 'function'); 
            this.rfidtype = 'fc_rfid'; this.$store.commit('setCardsType', 'fc_rfid'); 
            this.editmode = { status: false, tokenlist: [] };this.editusermode = { status: false, uidlist: [] };
            this.searchfilter = '';
            this.filterboxid = MESH_FILTER_ID; this.filterpicker(this.filterboxid);
          },
        },
      ],
      activeTab: this.$store.state.CardsTab,
      editmode: {
        status: false,
        tokenlist: []
      },
      editusermode: {
        status: false,
        uidlist: []
      },
      changerfidtype: 'rfid',
      rfidtypeoptions: [
        { value: 'rfid', label: this.$t('pairing.filterloadrfid') },
        { value: 'fc_rfid_pair', label: this.$t('pairing.functionrfids')+': '+this.$t('pairing.filterlearnfunction') },
        { value: 'fc_rfid_charge', label: this.$t('pairing.functionrfids')+': '+this.$t('pairing.filtersolarfunction') },
        { value: 'fc_rfid_lock', label: this.$t('pairing.functionrfids')+': '+this.$t('pairing.filterlockfunction') }
      ],
      newrfidid: 0,
      newrfidmodal: false,
      deletemodal: false,
      deleteusermodal: false,
      savewait: false,
      multieditmodal: false,
      multiusermodal: false,
      multicolormodal: false,
      deletepairtoken: '',
      deletepairname: '',
      deleteuser: [],
      rfidcounter: 25,
      filterboxid: MESH_FILTER_ID,
      rfidtype: this.$store.state.CardsType,
      selectedtab: this.$store.state.CardsTab,
      typNoOcpp: false,
      typEasyCheckIn: false,
      typGroupUser: false,
      typUser: false,
      selectuser: false,
      errormsgshow: false,
      errormsg: this.$t('pairing.norfids'),
      pair_modalshow: false,
      userauth_modalshow: false,
      addpair_modalshow: false,
      addpairtype: 'rfid',
      addpairuser: '-1',
      addpairname: '',
      addpairtoken: '',
      addpairclientgroup: '-1',
      addpaircolor: '#6B7280',
      user_modalshow: false,
      user_id: '-1',
      user_name: '',
      user_alias: '',
      aliasDirty: false, 
      updatingAliasFromName: false, 
      user_email: '',
      user_address: '',
      user_info: '',
      user_reference: '',
      user_status: 'active',
      user_creationoffset: '',
      user_authclients: [],
      lvpairtable: [],
      grouptable: [],
      clienttable: [],
      usertable: [],
      groupclienttable: [],
      rfidgroupclient: [],
      lvrfidgroupclient: [],
      usergroupclient: [],
      lvusergroupclient: [],
      lvuserserials: [],
      userlist: [],
      sortuserlist: this.$store.state.SortListRfid,
      sortlist: this.$store.state.SortListRfid,
      multieditselector: 'delete',
      multicolorcode: '#6B7280',
      filterblocked: false,
      searchfilter: '',
      selectedUser: null,
      allcheckcount: 0,
      pairchanged: false,
      pairsaved: false,
      userchanged: false,
      usersaved: false,
      allrfidtable: [],
      countpairs: 0,
      countpairname: '',
      countmeshpairs: 0,
      countorgpairs: 0,
      clut: ['#6B7280','#EF4444','#F97316','#F59E0B','#EAB308','#84CC16','#22C55E','#10B981','#14B8A6','#06B6D4','#0EA5E9','#3B82F6','#6366F1','#8B5CF6','#A855F7','#D946EF','#EC4899','#F43F5E'],
      clutname: [this.$t('pairing.clr01'),
        this.$t('pairing.clr02'),
        this.$t('pairing.clr03'),
        this.$t('pairing.clr04'),
        this.$t('pairing.clr05'),
        this.$t('pairing.clr06'),
        this.$t('pairing.clr07'),
        this.$t('pairing.clr08'),
        this.$t('pairing.clr09'),
        this.$t('pairing.clr10'),
        this.$t('pairing.clr11'),
        this.$t('pairing.clr12'),
        this.$t('pairing.clr13'),
        this.$t('pairing.clr14'),
        this.$t('pairing.clr15'),
        this.$t('pairing.clr16'),
        this.$t('pairing.clr17'),
        this.$t('pairing.clr18')],
      fullpairingapi: [],
      localpairingapi: [],
      lvfullpairing: [],
      edit_modalshow: false,
      cardtype_modal: '',
      carduser_modal: '',
      cardkey_modal: '',
      cardtoken_modal: '',
      cardname_modal: '',
      cardcolor_modal: '',
      cardstatus_modal: '',
      cardcreation_modal: '',
      isLoading: false,
    };
  },
  watch: {
    // Name geändert → Alias automatisch setzen (solange nicht manuell geändert)
    user_name(newVal) {
      //if (this.aliasDirty) return

      this.updatingAliasFromName = true
      this.user_alias = generateAlias(newVal)
      // nach dem Render-Zyklus das Flag wieder zurücksetzen
      this.$nextTick(() => {
        this.updatingAliasFromName = false
      })
    },

    // Alias geändert → max. 2 Zeichen, uppercase
    user_alias(newVal) {
      const sanitized = (newVal || '').toUpperCase().slice(0, 2)

      // Wenn Alias gerade aus dem Namen gesetzt wird:
      if (this.updatingAliasFromName) {
        // Nur ggf. sanitisieren, aber NICHT aliasDirty setzen
        if (sanitized !== newVal) {
          this.user_alias = sanitized
        }
        return
      }

      // Ab hier: echte User-Eingabe → Alias gilt als "manuell"
      this.aliasDirty = true

      if (sanitized !== newVal) {
        this.user_alias = sanitized
      }
    },
  },
  computed: {
    filteredPairings() {
      if (this.isLoading) {
        return [];
      }
      const filter = this.decodeHtml(this.searchfilter || "").toLowerCase();
      let filteredData = this.localpairingapi;

      if (this.filterblocked) {
        filteredData = filteredData.filter(card => card.status === 'disabled');
      }

      return filteredData.filter(item => {
        const { info, token, relation } = item;
        return (
          this.decodeHtml(info).toLowerCase().includes(filter) ||
          this.decodeHtml(token).toLowerCase().includes(filter) ||
          (relation && this.decodeHtml(relation).toLowerCase().includes(filter))
        );
      });
    },
    filteredUsers() {
      if (this.isLoading) {
        return [];
      }
      const filter = this.decodeHtml(this.searchfilter || "").toLowerCase();
      let filteredData = this.usertable;

      if (this.filterblocked) {
        filteredData = filteredData.filter(user => user.status === 'disabled');
      }

      return filteredData.filter(item => {
        const { name, alias, email, reference } = item;
        return (
          this.decodeHtml(name).toLowerCase().includes(filter) ||
          (alias && this.decodeHtml(alias).toLowerCase().includes(filter)) ||
          this.decodeHtml(email).toLowerCase().includes(filter) ||
          (reference && this.decodeHtml(reference).toLowerCase().includes(filter))
        );
      });
    },
    editcount() {
      return this.editmode.tokenlist?.length ?? 0;
    },
    editusercount() {
      return this.editusermode.uidlist?.length ?? 0;
    }
  },
  methods: {
    async apiGet(url, params = {}) {
      try {
        const { data } = await this.axios.get(url, { params });
        return data;
      } catch (err) {
        console.error('API error:', url, params, err);
        throw err;
      }
    },
    generateAlias(fullName) {
      if (!fullName) return ''

      const parts = fullName
        .trim()
        .split(/\s+/)
        .filter(Boolean)

      if (parts.length === 0) return ''

      const first = parts[0][0] || ''
      const last = parts.length > 1 ? parts[parts.length - 1][0] : ''

      const alias = (first + last).toUpperCase().slice(0, 2)
      console.log('generateAlias ->', fullName, '=>', alias)
      return alias
    },
    decodeHtml(html) {
      if (!this.decodeEl) {
        this.decodeEl = document.createElement("textarea");
      }
      this.decodeEl.innerHTML = html ?? '';
      return this.decodeEl.value;
    },

    MarkToEditAll(selectAll, isUser) {
      const listKey = isUser ? 'editusermode' : 'editmode';
      const idField = isUser ? 'userId' : 'token';
      const source = isUser ? this.filteredUsers : this.filteredPairings;

      const ids = selectAll ? source.map(entry => entry[idField]) : [];

      if (isUser) {
        this[listKey].uidlist = ids;
      } else {
        this[listKey].tokenlist = ids;
      }

      source.forEach(entry => {
        entry.checked = selectAll;
      });
    },

    MarkToEdit(checked, id, isUser) {
      const listKey = isUser ? 'editusermode' : 'editmode';
      const arrayKey = isUser ? 'uidlist' : 'tokenlist';
      const list = this[listKey][arrayKey];

      if (checked && !list.includes(id)) {
        list.push(id);
      } else if (!checked) {
        const index = list.indexOf(id);
        if (index > -1) list.splice(index, 1);
      }
    },

    getClientName(filterboxid) {
      const client = this.groupclienttable.find(elem => elem.value === filterboxid);
      return client ? client.name : '';
    },

    onUserSelected(user) {
      this.selectedUser = user;
    },

    LoadingCSV(){
      let tzOffset = 0;
      let label = '';
      let CsvPairingsUrl = '';

      if (this.filterboxid == MESH_FILTER_ID || this.filterboxid == LOCAL_FILTER_ID){
        CsvPairingsUrl = 'wallbox/pairing.php?action=export_pairings&user='+this.$store.state.token+'&groupId=all&timeoffset='+tzOffset;
        label = this.$t('pairing.allregrfids');
      }
      else if(this.filterboxid==ALL_FILTER_ID){
        CsvPairingsUrl = 'wallbox/pairing.php?action=export_pairings&user='+this.$store.state.token+'&client=-1&timeoffset='+tzOffset;
        label = this.$t('pairing.allrfidsallboxes');
      }
      else if(this.filterboxid.slice(0,1)=='g'){
        CsvPairingsUrl = 'wallbox/pairing.php?action=export_pairings&user='+this.$store.state.token+'&groupId='+this.filterboxid.slice(1)+'&timeoffset='+tzOffset;
        label = this.$t('pairing.allrfidsingroup')+' '+this.groupclienttable[this.groupclienttable.findIndex(gb => gb.value == this.filterboxid)].name;
      }
      else{
        CsvPairingsUrl = 'wallbox/pairing.php?action=export_pairings&user='+this.$store.state.token+'&client='+this.filterboxid.slice(1)+'&timeoffset='+tzOffset;
        if(this.$store.state.Mesh)
          label = this.$t('pairing.allrfidsonbox')+' '+this.groupclienttable[this.groupclienttable.findIndex(gb => gb.value == this.filterboxid)].name;
        else
          label = this.$t('pairing.allrfidsonbox')+' '+this.$store.state.WbName;
      }
      this.axios
        .get(CsvPairingsUrl)
        .then((response) => {
          if(response.data.status=='ok'){
            this.axios.get(response.data.link, { responseType: 'blob' })
              .then(response => {
                const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = label+'.csv'
                link.click()
                URL.revokeObjectURL(link.href)
              }).catch(console.error);
          }else{
            console.log('Error export Pairings CSV');
          }

        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    async addpair_confirm() {
      const API_URL = 'wallbox/pairing.php';
      const params = {
        action: 'add_pairing',
        user: this.$store.state.token,
        userId: this.addpairuser,
        token: this.addpairtoken,
        info: this.addpairname,                // axios will encode
        color: this.addpaircolor.substring(1), // remove '#'
        typ: this.addpairtype,
        client: -1,
        groupId: -1,
      };

      if (this.selectedUser) {
        this.addpairtype = this.selectedUser.typ;
        params.typ = this.addpairtype;
        params.relation = this.selectedUser.relation;
      }

      if (this.$store.state.Mesh) {
        const val = this.addpairclientgroup;
        if (val === '-1') {
          params.client = 'all';
          params.groupId = 'all';
        } else if (val.startsWith('g')) {
          params.client = -1;
          params.groupId = val.slice(1);
        } else {
          params.client = val.slice(1);
          params.groupId = -1;
        }
      } 
      // else: defaults client=-1, groupId=-1 already set

      try {
        const response = await this.axios.get(API_URL, { params });

        if (response.data.status === 'ok') {

         // -----------------------------------
          // PAIRING-SYNC NUR AUSFÜHREN WENN EIN USER GESETZT IST
          // -----------------------------------
          if (String(this.addpairuser) !== '-1') {

            // User holen
            const user = this.usertable.find(u => u.userId === this.addpairuser);

            if (!user) {
              console.warn('User für Karte nicht gefunden, UserId:', this.addpairuser);
            } else {
              // authorizedClients.clients = [{ serial:'...' }, ...]
              const authorizedSerials = new Set(
                (user.authorizedClients?.clients || [])
                  .map(c => c.serial)
                  .filter(Boolean)
              );

              // -----------------------------------
              // NEU: Wenn authorizedSerials leer → ABBRECHEN
              // -----------------------------------
              if (authorizedSerials.size === 0) {
                console.warn('Keine authorizedClients vorhanden → Pairing-Sync übersprungen.');
                // UI trotzdem aktualisieren
                //this.filterpicker(this.filterboxid);
                this.reloadpage();
                this.addpair_modalshow = false;
                return;   // <-- HARTER ABBRUCH
              }

              // Clients nach add/remove sortieren
              const clientsToAdd = [];
              const clientsToRemove = [];

              this.clienttable.forEach(client => {
                const clientSerial = client.serial;

                if (!clientSerial) {
                  console.warn('Client ohne Serial in clienttable, id:', client.id);
                  return;
                }

                if (authorizedSerials.has(clientSerial)) {
                  clientsToAdd.push(client);
                } else {
                  clientsToRemove.push(client);
                }
              });

              const failedClients = new Set();

              // 1) ADD zuerst
              if (clientsToAdd.length > 0) {
                const addRequests = clientsToAdd.map(client =>
                  this.apiGet(API_URL, {
                    action: 'add_pairing_to',
                    user: this.$store.state.token,
                    client: client.id,
                    token: this.addpairtoken
                  })
                );

                const addResults = await Promise.allSettled(addRequests);

                addResults.forEach((res, index) => {
                  if (res.status === 'rejected') {
                    const client = clientsToAdd[index];
                    console.error(
                      `ADD Pairing fehlgeschlagen für Client ${client.id} (${client.name})`,
                      res.reason
                    );
                    failedClients.add(client.id);
                  }
                });
              }

              // 2) REMOVE danach
              if (clientsToRemove.length > 0) {
                const removeRequests = clientsToRemove.map(client =>
                  this.apiGet(API_URL, {
                    action: 'remove_pairing_from',
                    user: this.$store.state.token,
                    client: client.id,
                    token: this.addpairtoken
                  })
                );

                const removeResults = await Promise.allSettled(removeRequests);

                removeResults.forEach((res, index) => {
                  if (res.status === 'rejected') {
                    const client = clientsToRemove[index];
                    console.error(
                      `REMOVE Pairing fehlgeschlagen für Client ${client.id} (${client.name})`,
                      res.reason
                    );
                    failedClients.add(client.id);
                  }
                });
              }

              if (failedClients.size > 0) {
                console.warn(
                  'Folgende Clients konnten nicht synchronisiert werden:',
                  Array.from(failedClients)
                );
              }
            }
          }





          //this.filterpicker(this.filterboxid);

          this.addpairtype = 'rfid';
          this.addpairname = '';
          this.selectedUser = null;
          this.addpairtoken = '';
          this.addpaircolor = '#6B7280';
          this.reloadpage();
          this.addpair_modalshow = false;
        } else {
          console.log('Error send manual pairing data');
          // optionally show a user-facing error here
        }
      } catch (error) {
        console.log(error);
        // optionally show a user-facing error here
      }
    },

    async deletemarkedpairs(tokens) {
      const API_URL = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;

      try {
        const deletePromises = tokens.map(token =>
          this.apiGet(API_URL, {
            action: 'remove_pairing_from',
            user: userToken,
            token,
            client: 'all'
          })
        );

        await Promise.allSettled(deletePromises);

        try {
          const response = await this.apiGet(API_URL, {
            action: 'refresh_pairings_async',
            user: userToken
          });

          if (response?.status === RESPONSE_OK) {
            console.log('Pairings refreshed successfully');
          } else {
            console.error('Error refreshing pairings');
          }
        } catch (refreshError) {
          console.error('API Error during refresh:', refreshError);
        }

      } catch (error) {
        console.error('Error deleting pairings:', error);
      } finally {
        this.editmode.status = false;
        this.MarkToEditAll(false,false);
        this.filterpicker(this.filterboxid);
        this.deletemodal = false;
      }
    },

    async deletemarkedusers(userids) {
      const API_URL = 'wallbox/user.php';
      const userToken = this.$store.state.token;

      try {
        const deletePromises = userids.map(userid =>
          this.apiGet(API_URL, {
            action: 'user_delete',
            user: userToken,
            user_id: userid
          })
        );

        await Promise.allSettled(deletePromises);

        try {
          const response = await this.apiGet('wallbox/pairing.php', {
            action: 'refresh_pairings_async',
            user: userToken
          });

          if (response?.status === RESPONSE_OK) {
            console.log('Pairings refreshed successfully');
          } else {
            console.error('Error refreshing pairings');
          }
        } catch (refreshError) {
          console.error('API Error during refresh:', refreshError);
        }

      } catch (error) {
        console.error('Error deleting users:', error);
      } finally {
        this.editusermode.status = false;
        this.MarkToEditAll(false,false);
        this.reloadpage();
        this.savewait = false;
        this.deleteusermodal = false;
      }
    },

    deletepair(token) {
      const API_URL = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;

      this.axios.get(API_URL, {
        params: {
          action: 'remove_pairing_from',
          user: userToken,
          token,
          client: 'all'
        }
      })
        .then(response => {
          if (response?.data?.status === RESPONSE_OK) {
            this.filterpicker(this.filterboxid);
            this.deletemodal = false;
          } else {
            console.error('Error: Failed to delete pairing from all clients.');
          }
        })
        .catch(error => {
          console.error('API Error:', error);
        });
    },

    deleteoneuser(userid) {
      const API_URL = 'wallbox/user.php';
      const userToken = this.$store.state.token;

      this.axios.get(API_URL, {
        params: {
          action: 'user_delete',
          user: userToken,
          user_id: userid
        }
      })
        .then(response => {
          if (response?.data?.status === RESPONSE_OK) {
            this.reloadpage();
            this.savewait = false;
            this.deleteusermodal = false;
          } else {
            console.error('Error: Failed to delete user.');
          }
        })
        .catch(error => {
          console.error('API Error:', error);
        });
    },

    addnewrfid(client){
      this.axios
        .get('wallbox/pairing.php?action=search_rfid&user='+this.$store.state.token+'&client='+client)
        .then((response) => {
          if(response.data.status=='pending'){
            this.newrfidid=response.data.id;
            this.rfidcounter=25;
            this.newrfidmodal=true;
          }else{
            console.log('Error Search Pairing');
          }
          (response.data.status=='pending') ? setTimeout(() => {  this.execpoll(this.polling,client); }, 1000) : null
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    pollnewrfid(client){
      if(this.polling){
        this.axios
          .get('wallbox/info.php?action=get_request_status&user='+this.$store.state.token+'&id='+this.newrfidid+'&client='+client)
          .then((response) => {
            if(response.data.status=='pending'){
              this.newrfidmodal=true;
              this.rfidcounter--;
            }
            if(response.data.status=='parameter'||this.rfidcounter==0){
              this.newrfidmodal=false;
              this.isLoading = true;
              this.axios
                .get('wallbox/pairing.php?action=refresh_pairings&user='+this.$store.state.token)
                .then((responserefresh) => {
                  if(responserefresh.data.status=='ok'||responserefresh.data.status=='network'){
                    this.filterpicker(this.filterboxid);
                    this.isLoading = false;
                  }
                })
                .catch((errors) => {
                  console.error(errors);
                });
            }
            (response.data.status=='pending'&&this.rfidcounter>0) ? setTimeout(() => {  this.execpoll(this.polling,client); }, 1000) : null
          })
          .catch((errors) => {
            console.error(errors);
            this.execpoll(this.polling);
          });
      }
    },

    execpoll(polling,client){
      if(polling){
        this.pollnewrfid(client);
      }
    },

    copyToClipBoard(textToCopy){
      navigator.clipboard.writeText(textToCopy);
    },

    async updatePairingsForSelected(extraParamsBuilder) {
      const tokens = this.editmode.tokenlist;
      if (!tokens.length) return;

      const API_URL = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;

      try {
        const tasks = tokens.map(token =>
          this.apiGet(API_URL, {
            action: 'update_pairing',
            user: userToken,
            token,
            ...extraParamsBuilder(token),
          })
        );
        await Promise.all(tasks);

        this.editmode.tokenlist = [];
        this.filterpicker(this.filterboxid);
      } catch (err) {
        console.error('Bulk update pairing failed:', err);
      }
    },

    async changepairingtype(rfidtype) {
      this.multieditmodal=false;
      await this.updatePairingsForSelected(() => ({ typ: rfidtype }));
    },

    async changepairinguser(userid) {
      this.multiusermodal=false;
      await this.updatePairingsForSelected(() => ({ userId: userid }));
    },

    async changepairingcolor(multicolor) {
      this.multicolormodal=false;
      await this.updatePairingsForSelected(() => ({
        color: multicolor.slice(1),
      }));
    },

    async applyBulkOrSingle({ isBulk, list, buildParams, url, afterSuccess }) {
      const userToken = this.$store.state.token;

      try {
        if (isBulk) {
          const tasks = list.map(id => {
            const params = buildParams(id, userToken);
            return this.apiGet(url, params);
          });
          await Promise.all(tasks);
        } else {
          const id = list;
          const params = buildParams(id, userToken);
          const data = await this.apiGet(url, params);
          if (data.status !== RESPONSE_OK) {
            console.error('Operation failed:', url, params);
          }
        }

        if (afterSuccess) afterSuccess();
      } catch (error) {
        console.error('Bulk/single operation failed:', error);
      }
    },

    async switchuserstatus(userid, status) {
      this.isLoading = true;
      const isBulk = this.editusermode.status;
      const list = isBulk ? this.editusermode.uidlist : userid;

      await this.applyBulkOrSingle({
        isBulk,
        list,
        url: 'wallbox/user.php',
        buildParams: (id, userToken) => ({
          action: 'user_update',
          user: userToken,
          user_id: id,
          user_status: status,
        }),
        afterSuccess: () => {
          this.editusermode.uidlist = [];
          this.isLoading = false;
          this.reloadpage();
        }
      });
    },

    async switchstatus(rfid, status) {
      const isBulk = this.editmode.status;
      const list = isBulk ? this.editmode.tokenlist : rfid;

      await this.applyBulkOrSingle({
        isBulk,
        list,
        url: 'wallbox/pairing.php',
        buildParams: (token, userToken) => ({
          action: 'update_pairing',
          user: userToken,
          token,
          status,
        }),
        afterSuccess: () => {
          this.editmode.tokenlist = [];
          this.filterpicker(this.filterboxid);
        }
      });
    },

    sortPairings(a, b) {
      const dateA = new Date(a.creation);
      const dateB = new Date(b.creation);
      if (this.sortlist === 'nameup') {
        return a.info.localeCompare(b.info);
      } else if (this.sortlist === 'namedown') {
        return b.info.localeCompare(a.info);
      } else if (this.sortlist === 'dateup') {
        return dateA < dateB ? 1 : dateA > dateB ? -1 : 0;
      } else if (this.sortlist === 'datedown') {
        return dateB < dateA ? 1 : dateB > dateA ? -1 : 0;
      }
      return a.info.localeCompare(b.info);
    },

    sortUsers(a, b) {
      const dateA = new Date(a.creation);
      const dateB = new Date(b.creation);
      if (this.sortuserlist === 'nameup') {
        return a.name.localeCompare(b.name);
      } else if (this.sortuserlist === 'namedown') {
        return b.name.localeCompare(a.name);
      } else if (this.sortuserlist === 'dateup') {
        return dateA < dateB ? 1 : dateA > dateB ? -1 : 0;
      } else if (this.sortuserlist === 'datedown') {
        return dateB < dateA ? 1 : dateB > dateA ? -1 : 0;
      }
      return a.name.localeCompare(b.name);
    },

    buildPairingUrl(filter) {
      const baseApiUrl = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;

      if (this.$store.state.Mesh) {
        if (filter === MESH_FILTER_ID) {
          return {
            url: baseApiUrl,
            params: { action: 'list_dist_pairings', user: userToken, typ: this.rfidtype },
          };
        } else if (filter === ALL_FILTER_ID) {
          return {
            url: baseApiUrl,
            params: { action: 'list_pairings', user: userToken, client: -1, typ: this.rfidtype },
          };
        } else if (filter.startsWith('g')) {
          return {
            url: baseApiUrl,
            params: { action: 'list_pairings', user: userToken, groupId: filter.slice(1), typ: this.rfidtype },
          };
        } else {
          return {
            url: baseApiUrl,
            params: { action: 'list_pairings', user: userToken, client: filter.slice(1), typ: this.rfidtype },
          };
        }
      } else {
        return {
          url: baseApiUrl,
          params: { action: 'list_pairings', user: userToken, client: -1, typ: this.rfidtype },
        };
      }
    },

    normalizePairings(pairings) {
      this.typEasyCheckIn = false;
      this.typGroupUser = false;
      this.typUser = false;
      this.typNoOcpp = false;
      this.userlist = [];

      const helperArray = pairings.map((pairingRaw) => {
        const pairing = { ...pairingRaw };
        pairing.checked = false;
        pairing.token = this.decodeHtml(pairing.token);
        pairing.info = this.decodeHtml(pairing.info);
        pairing.relation = this.decodeHtml(pairing.relation);
        pairing.color = pairing.color ? `#${pairing.color}` : '#6b7280';

        const matchedUser = this.usertable.find((user) => user.userId === pairing.user);
        pairing.username = matchedUser ? matchedUser.name : '';
        pairing.alias = matchedUser ? matchedUser.alias : '';
        //pairing.username = matchedUser
        //  ? (matchedUser.alias?.trim() ? matchedUser.alias : matchedUser.name || '')
        //  : '';

        const tzOffset = new Date(pairing.creation).getTimezoneOffset();
        pairing.creationoffset = this.$t('common.time', {
          time: this.$dayjs(this.$dayjs(pairing.creation).subtract(tzOffset, 'minute')).format('DD.MM.YYYY - HH:mm'),
        });

        if (pairing.typ === 'rfid_checkin') this.typEasyCheckIn = true;
        if (pairing.typ === 'rfid_local') this.typNoOcpp = true;
        if (pairing.user !== '') this.typUser = true;
        if (pairing.typ.includes('rfid_user')) {
          this.typGroupUser = true;
          if (!this.userlist.some(u => u.typ === pairing.typ && u.relation === pairing.relation)) {
            this.userlist.push({
              typ: pairing.typ,
              relation: pairing.relation || 'Unknown',
            });
          }
        }

        return pairing;
      });

      helperArray.sort((a, b) => this.sortPairings(a, b));
      return helperArray;
    },

    applyFilterResult(helperArray) {
      this.localpairingapi = helperArray;
      this.allrfidtable = helperArray;
      this.countorgpairs = helperArray.length;
      this.countpairname = this.$t('pairing.registeredpairs');
    },

    async filterpicker(filter) {
      this.isLoading = true;
      this.countpairs = 0;
      this.countorgpairs = 0;
      this.countmeshpairs = 0;
      this.localpairingapi = [];
      this.errormsgshow = false;

      try {
        const { url, params } = this.buildPairingUrl(filter);
        const data = await this.apiGet(url, params);

        const responseData = data.tbl_remote_pairing || [];
        if (!responseData || responseData.length === 0) {
          this.errormsgshow = true;
          return;
        }

        let processedData = responseData;

        if (filter !== MESH_FILTER_ID && this.$store.state.Mesh) {
          const groupedByToken = responseData.reduce((acc, card) => {
            if (!acc[card.token]) acc[card.token] = [];
            acc[card.token].push(card);
            return acc;
          }, {});

          const clientCount =
            this.groupclienttable.find(grp => grp.value === filter)?.clientcount || 0;

          processedData = Object.values(groupedByToken)
            .filter(group => group.length >= clientCount)
            .map(group => group[0]);
        }

        const helperArray = this.normalizePairings(processedData);
        this.applyFilterResult(helperArray);
      } catch (err) {
        console.error('Error in filterpicker:', err);
        this.errormsgshow = true;
      } finally {
        this.isLoading = false;
      }
    },

    async save_edit() {
      const API_URL = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;
      const cardToken = this.cardtoken_modal;

      const params = {
        action: 'update_pairing',
        user: userToken,
        token: this.cardtoken_modal,
        status: this.cardstatus_modal,
        info: this.cardname_modal,
        color: this.cardcolor_modal.substring(1),
        typ: this.cardtype_modal,
        userId: this.carduser_modal
      };

      try {
        const response = await this.apiGet(API_URL, params);

        if (response?.status === RESPONSE_OK) {

          // -----------------------------------
          // PAIRING-SYNC NUR AUSFÜHREN WENN EIN USER GESETZT IST
          // -----------------------------------
          if (String(this.carduser_modal) !== '-1') {

            // User holen
            const user = this.usertable.find(u => u.userId === this.carduser_modal);

            if (!user) {
              console.warn('User für Karte nicht gefunden, UserId:', this.carduser_modal);
            } else {
              // authorizedClients.clients = [{ serial:'...' }, ...]
              const authorizedSerials = new Set(
                (user.authorizedClients?.clients || [])
                  .map(c => c.serial)
                  .filter(Boolean)
              );

              // -----------------------------------
              // NEU: Wenn authorizedSerials leer → ABBRECHEN
              // -----------------------------------
              if (authorizedSerials.size === 0) {
                console.warn('Keine authorizedClients vorhanden → Pairing-Sync übersprungen.');
                // UI trotzdem aktualisieren
                //this.filterpicker(this.filterboxid);
                this.reloadpage();

                this.edit_modalshow = false;
                return;   // <-- HARTER ABBRUCH
              }

              // Clients nach add/remove sortieren
              const clientsToAdd = [];
              const clientsToRemove = [];

              this.clienttable.forEach(client => {
                const clientSerial = client.serial;

                if (!clientSerial) {
                  console.warn('Client ohne Serial in clienttable, id:', client.id);
                  return;
                }

                if (authorizedSerials.has(clientSerial)) {
                  clientsToAdd.push(client);
                } else {
                  clientsToRemove.push(client);
                }
              });

              const failedClients = new Set();

              // 1) ADD zuerst
              if (clientsToAdd.length > 0) {
                const addRequests = clientsToAdd.map(client =>
                  this.apiGet(API_URL, {
                    action: 'add_pairing_to',
                    user: userToken,
                    client: client.id,
                    token: cardToken
                  })
                );

                const addResults = await Promise.allSettled(addRequests);

                addResults.forEach((res, index) => {
                  if (res.status === 'rejected') {
                    const client = clientsToAdd[index];
                    console.error(
                      `ADD Pairing fehlgeschlagen für Client ${client.id} (${client.name})`,
                      res.reason
                    );
                    failedClients.add(client.id);
                  }
                });
              }

              // 2) REMOVE danach
              if (clientsToRemove.length > 0) {
                const removeRequests = clientsToRemove.map(client =>
                  this.apiGet(API_URL, {
                    action: 'remove_pairing_from',
                    user: userToken,
                    client: client.id,
                    token: cardToken
                  })
                );

                const removeResults = await Promise.allSettled(removeRequests);

                removeResults.forEach((res, index) => {
                  if (res.status === 'rejected') {
                    const client = clientsToRemove[index];
                    console.error(
                      `REMOVE Pairing fehlgeschlagen für Client ${client.id} (${client.name})`,
                      res.reason
                    );
                    failedClients.add(client.id);
                  }
                });
              }

              if (failedClients.size > 0) {
                console.warn(
                  'Folgende Clients konnten nicht synchronisiert werden:',
                  Array.from(failedClients)
                );
              }
            }
          }

          // UI-Refresh
          //this.filterpicker(this.filterboxid);
          this.reloadpage();
        } else {
          console.error('Error: Saving pairing data failed.', response);
        }
      } catch (error) {
        console.error('API Error (update_pairing):', error);
      } finally {
        this.edit_modalshow = false;
      }
    },

    save_user() {
      this.isLoading = true;
      const API_URL = 'wallbox/user.php';
      const userToken = this.$store.state.token;

      const params = {
        action: 'user_update',
        user: userToken,
        user_id: this.user_id,
        user_name: this.user_name,
        user_alias: this.user_alias,
        user_email: this.user_email,
        user_address: this.user_address,
        user_status: this.user_status,
        user_reference: this.user_reference,
        user_info: this.user_info,
      };

      this.axios.get(API_URL, { params })
        .then(response => {
          if (response?.data?.status === RESPONSE_OK) {
            this.reloadpage();
          } else {
            console.error('Error: Saving user data failed.');
          }
        })
        .catch(error => {
          console.error('API Error:', error);
        })
        .finally(() => {
          this.isLoading = false;
          this.user_modalshow = false;
        });
    },

    setClientSelection(groupId, clientId, selected) {
      const group = this.lvrfidgroupclient.find(g => g.groupId === groupId);
      if (!group) {
        console.warn(`setClientSelection: group ${groupId} not found`);
        return;
      }

      const box = group.group.find(b => b.id === clientId);
      if (!box) {
        console.warn(`setClientSelection: client ${clientId} not found in group ${groupId}`);
        return;
      }

      const client = this.clienttable.find(c => c.id === clientId);
      if (!client) {
        console.warn(`setClientSelection: client ${clientId} not found in clienttable`);
        return;
      }

      // If state is already as requested, do nothing (avoid double counting)
      if (box.boxcheck === selected) return;

      box.boxcheck = selected;
      client.isChecked = selected;

      // Keep group checkcount in bounds
      if (selected) {
        group.checkcount++;
      } else if (group.checkcount > 0) {
        group.checkcount--;
      }

      // Keep global count in bounds
      if (selected) {
        this.allcheckcount++;
      } else if (this.allcheckcount > 0) {
        this.allcheckcount--;
      }
    },
    setUserSelection(groupId, clientId, selected) {
      const group = this.lvusergroupclient.find(g => g.groupId === groupId);
      if (!group) {
        console.warn(`setUserSelection: group ${groupId} not found`);
        return;
      }

      const box = group.group.find(b => b.id === clientId);
      if (!box) {
        console.warn(`setUserSelection: client ${clientId} not found in group ${groupId}`);
        return;
      }

      const client = this.clienttable.find(c => c.id === clientId);
      if (!client) {
        console.warn(`setUserSelection: client ${clientId} not found in clienttable`);
        return;
      }

      // If state is already as requested, do nothing (avoid double counting)
      if (box.boxcheck === selected) return;

      box.boxcheck = selected;
      client.isUserChecked = selected;

      if (selected) {
        // Add only if not already in the list
        const exists = this.lvuserserials.some(item => item.serial === client.serial);
        if (!exists) {
          this.lvuserserials.push({ serial: client.serial });
        }
      } else {
        // Remove if it exists
        const index = this.lvuserserials.findIndex(item => item.serial === client.serial);
        if (index > -1) {
          this.lvuserserials.splice(index, 1);
        }
      }
      // Keep group checkcount in bounds
      if (selected) {
        group.checkcount++;
      } else if (group.checkcount > 0) {
        group.checkcount--;
      }

      // Keep global count in bounds
      if (selected) {
        this.allcheckcount++;
      } else if (this.allcheckcount > 0) {
        this.allcheckcount--;
      }
    },

    addpairtoclient(gruppe, client) {
      this.setClientSelection(gruppe, client, true);
    },
    addusertoclient(gruppe, client) {
      this.setUserSelection(gruppe, client, true);
    },

    removepairfromclient(gruppe, client) {
      this.setClientSelection(gruppe, client, false);
    },
    removeuserfromclient(gruppe, client) {
      this.setUserSelection(gruppe, client, false);
    },

    addpairtogroup(gruppe) {
      const group = this.lvrfidgroupclient.find(g => g.groupId === gruppe);
      if (!group) {
        console.warn(`addpairtogroup: group ${gruppe} not found`);
        return;
      }

      group.group.forEach(box => {
        this.setClientSelection(gruppe, box.id, true);
      });
    },
    addusertogroup(gruppe) {
      const group = this.lvusergroupclient.find(g => g.groupId === gruppe);
      if (!group) {
        console.warn(`addpairtogroup: group ${gruppe} not found`);
        return;
      }

      group.group.forEach(box => {
        this.setUserSelection(gruppe, box.id, true);
      });
    },

    removepairfromgroup(gruppe) {
      const group = this.lvrfidgroupclient.find(g => g.groupId === gruppe);
      if (!group) {
        console.warn(`removepairfromgroup: group ${gruppe} not found`);
        return;
      }

      group.group.forEach(box => {
        this.setClientSelection(gruppe, box.id, false);
      });
    },
    removeuserfromgroup(gruppe) {
      const group = this.lvusergroupclient.find(g => g.groupId === gruppe);
      if (!group) {
        console.warn(`removepairfromgroup: group ${gruppe} not found`);
        return;
      }

      group.group.forEach(box => {
        this.setUserSelection(gruppe, box.id, false);
      });
    },

    addpairtoall() {
      this.lvrfidgroupclient.forEach(group => {
        group.group.forEach(box => {
          this.setClientSelection(group.groupId, box.id, true);
        });
      });
    },
    addusertoall() {
      this.lvusergroupclient.forEach(group => {
        group.group.forEach(box => {
          this.setUserSelection(group.groupId, box.id, true);
        });
      });
    },

    removepairfromall() {
      this.lvrfidgroupclient.forEach(group => {
        group.group.forEach(box => {
          this.setClientSelection(group.groupId, box.id, false);
        });
      });

      // Optional safety reset (should already be correct, but ensures consistency)
      this.allcheckcount = 0;
    },
    removeuserfromall() {
      this.lvusergroupclient.forEach(group => {
        group.group.forEach(box => {
          this.setUserSelection(group.groupId, box.id, false);
        });
      });

      // Optional safety reset (should already be correct, but ensures consistency)
      this.allcheckcount = 0;
    },
    async savepairings(karte) {
      const API_URL = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;

      this.pairsaved = false;

      if (!userToken) {
        console.error('Kein User-Token – Pairings können nicht gespeichert werden.');
        return;
      }

      // 1) Nur Clients mit Änderung berücksichtigen
      //const changedClients = this.clienttable.filter(
      //  client => client.isChecked !== client.savedIsChecked
      //);
      const changedClients = this.clienttable;

      if (changedClients.length === 0) {
        console.log('Keine Änderungen an Pairings – nichts zu speichern.');
        this.pairsaved = true;
        return;
      }

      // --- NEU: getrennte Listen nach Aktion ---
      const clientsToAdd = changedClients.filter(c => c.isChecked);
      const clientsToRemove = changedClients.filter(c => !c.isChecked);

      try {
        const failedClientIds = [];

        //
        // 2) ZUERST ADD-PAIRINGS AUSFÜHREN
        //
        if (clientsToAdd.length > 0) {
          const addRequests = clientsToAdd.map(client =>
            this.apiGet(API_URL, {
              action: 'add_pairing_to',
              user: userToken,
              client: client.id,
              token: karte
            })
          );

          const addResults = await Promise.allSettled(addRequests);

          addResults.forEach((res, index) => {
            const client = clientsToAdd[index];
            if (res.status === 'rejected') {
              console.error(
                `ADD fehlgeschlagen für Client ${client.id} (${client.name}):`,
                res.reason
              );
              failedClientIds.push(client.id);
            }
          });
        }

        //
        // 3) DANN REMOVE-PAIRINGS AUSFÜHREN
        //
        if (clientsToRemove.length > 0) {
          const removeRequests = clientsToRemove.map(client =>
            this.apiGet(API_URL, {
              action: 'remove_pairing_from',
              user: userToken,
              client: client.id,
              token: karte
            })
          );

          const removeResults = await Promise.allSettled(removeRequests);

          removeResults.forEach((res, index) => {
            const client = clientsToRemove[index];
            if (res.status === 'rejected') {
              console.error(
                `REMOVE fehlgeschlagen für Client ${client.id} (${client.name}):`,
                res.reason
              );
              failedClientIds.push(client.id);
            }
          });
        }

        //
        // 4) Erfolgreiche Clients als gespeichert markieren
        //
        changedClients.forEach(client => {
          if (!failedClientIds.includes(client.id)) {
            client.savedIsChecked = client.isChecked;
          }
        });

        if (failedClientIds.length > 0) {
          console.warn('Folgende Clients konnten nicht gespeichert werden:', failedClientIds);
        }

        //
        // 5) Refresh (optional)
        //
        try {
          const response = await this.apiGet(API_URL, {
            action: 'refresh_pairings_async',
            user: userToken
          });

          if (response?.status === RESPONSE_OK) {
            console.log('Pairings refreshed successfully');
          } else {
            console.error('Error refreshing pairings', response);
          }
        } catch (refreshError) {
          console.error('API Error during refresh:', refreshError);
        }

        //
        // 6) Erfolgs-Flag setzen
        //
        this.pairsaved = failedClientIds.length === 0;
      } catch (error) {
        console.error('Error saving pairings:', error);
      }
    },

    async saveuserpairings(user_id) {
      const API_URL = 'wallbox/pairing.php';
      const userToken = this.$store.state.token;

      this.usersaved = false;

      // ---------------------------------------------------------
      // NEU: User-Client-Zuordnung zuerst aktualisieren
      // ---------------------------------------------------------
      try {
        const output = {
          clients: this.lvuserserials
        };
        const userClientsJson = JSON.stringify(output);
        await this.apiGet('wallbox/user.php', {
          action: 'user_update_clients',
          user: userToken,
          user_id: user_id,
          user_clients: userClientsJson
        });

        console.log('user_update_clients erfolgreich ausgeführt:', this.lvuserserials);

      } catch (err) {
        console.error('Fehler bei user_update_clients:', err);
        // Wenn dieser API Call fehlschlägt → direkten Abbruch
        return;
      }
      // ---------------------------------------------------------

      // 1) User + Karten (rfidtbl.token) holen
      const user = this.usertable.find(u => u.userId === user_id);

      if (!user) {
        console.error('User not found:', user_id);
        return;
      }

      const cards = (user.rfidtbl || []).filter(r => !!r.token);
      console.log('cards',cards);
      if (cards.length === 0) {
        console.log('User hat keine Karten (rfidtbl ist leer).');
        this.usersaved = true;
        return;
      }

      // 2) Nur Clients mit geänderten Pairings (Diff-only)
      //const changedClients = this.clienttable.filter(
      //  client => client.isChecked !== client.savedIsChecked
      //);
console.log('this.clienttable',this.clienttable);     
      // 2) Alle Clients
      const changedClients = this.clienttable;
console.log('changedClients',changedClients);
      if (changedClients.length === 0) {
        console.log('Keine Änderungen an User-Pairings – nichts zu speichern.');
        this.usersaved = true;
        return;
      }

      // NEU: Clients in "add" und "remove" aufteilen
      const clientsToAdd = changedClients.filter(c => c.isUserChecked);
      const clientsToRemove = changedClients.filter(c => !c.isUserChecked);
console.log('clientsToAdd',clientsToAdd);
console.log('clientsToRemove',clientsToRemove);
      try {
        const failedClientIds = new Set();

        //
        // 3) ZUERST: ADD-Pairings für alle Karten des Users
        //
        if (clientsToAdd.length > 0) {
          const addRequests = [];
          const addMeta = [];

          for (const client of clientsToAdd) {
            for (const card of cards) {
              addRequests.push(
                this.apiGet(API_URL, {
                  action: 'add_pairing_to',
                  user: userToken,
                  client: client.id,
                  token: card.token
                })
              );

              addMeta.push({
                clientId: client.id,
                clientName: client.name,
                token: card.token
              });
            }
          }

          const addResults = await Promise.allSettled(addRequests);

          addResults.forEach((res, index) => {
            if (res.status === 'rejected') {
              const info = addMeta[index];
              console.error(
                `User-Pairing ADD fehlgeschlagen für Client ${info.clientId} (${info.clientName}), Karte ${info.token}:`,
                res.reason
              );
              failedClientIds.add(info.clientId);
            }
          });
        }

        //
        // 4) DANACH: REMOVE-Pairings für alle Karten des Users
        //
        if (clientsToRemove.length > 0) {
          const removeRequests = [];
          const removeMeta = [];

          for (const client of clientsToRemove) {
            for (const card of cards) {
              removeRequests.push(
                this.apiGet(API_URL, {
                  action: 'remove_pairing_from',
                  user: userToken,
                  client: client.id,
                  token: card.token
                })
              );

              removeMeta.push({
                clientId: client.id,
                clientName: client.name,
                token: card.token
              });
            }
          }

          const removeResults = await Promise.allSettled(removeRequests);

          removeResults.forEach((res, index) => {
            if (res.status === 'rejected') {
              const info = removeMeta[index];
              console.error(
                `User-Pairing REMOVE fehlgeschlagen für Client ${info.clientId} (${info.clientName}), Karte ${info.token}:`,
                res.reason
              );
              failedClientIds.add(info.clientId);
            }
          });
        }

        if (failedClientIds.size > 0) {
          console.warn(
            'Für folgende Clients konnten nicht alle User-Pairings gespeichert werden:',
            Array.from(failedClientIds)
          );
        }

        //
        // 5) Nur erfolgreiche Clients als "gespeichert" markieren
        //
        changedClients.forEach(client => {
          if (!failedClientIds.has(client.id)) {
            client.savedIsChecked = client.isChecked;
          }
        });

        //
        // 6) Optional: Serverseitigen Refresh anstoßen
        //
        try {
          const response = await this.apiGet(API_URL, {
            action: 'refresh_pairings_async',
            user: userToken
          });

          if (response?.status === RESPONSE_OK) {
            console.log('User-Pairings refreshed successfully');
          } else {
            console.error('Error refreshing user pairings', response);
          }
        } catch (refreshError) {
          console.error('API Error during refresh (user pairings):', refreshError);
        }

        // Optional: Wenn du Erfolg/Fehler unterscheiden willst:
        // this.usersaved = failedClientIds.size === 0;
        this.usersaved = true;

      } catch (error) {
        console.error('Error saving user pairings:', error);
      }
    },


    async reload_pair(karte) {
      // Reset state
      this.rfidgroupclient = [];
      this.allcheckcount = 0;
      this.pairchanged = false;

      // 1) Build group list
      this.rfidgroupclient = this.grouptable.map((g, index) => ({
        groupId: g.id,
        name: g.name,
        info: g.info,
        nr: index + 1,
        checkcount: 0,
        group: []
      }));

      // Map groupId -> group for fast lookup
      const groupById = new Map(
        this.rfidgroupclient.map(g => [g.groupId, g])
      );

      // 2) Attach clients to their groups (no nested loops)
      for (const client of this.clienttable) {
        const group = groupById.get(client.groupId);
        if (!group) continue; // skip clients whose group doesn't exist

        group.group.push({
          id: client.id,
          groupId: client.groupId,
          name: client.name,
          serial: client.serial,
          boxcheck: false
        });
      }

      // 3) Remove groups with no clients
      this.rfidgroupclient = this.rfidgroupclient.filter(g => g.group.length > 0);

      // Rebuild map after filtering
      const filteredGroupById = new Map(
        this.rfidgroupclient.map(g => [g.groupId, g])
      );

      try {
        // 4) Load paired clients
        const { data } = await this.axios.get(
          `wallbox/pairing.php?action=list_clients_to_pairing&user=${this.$store.state.token}&token=${karte}`
        );

        if (data.status !== 'ok') {
          console.log('fehler reload pair');
          return;
        }

        // Sort without mutating original response array
        this.lvpairtable = data.tbl_clients.slice().sort((a, b) => a.idx - b.idx);

        // Map clientId -> client in clienttable for fast lookup
        const clientById = new Map(
          this.clienttable.map(c => [c.id, c])
        );

        // 5) Mark checked clients
        for (const pair of this.lvpairtable) {
          const group = filteredGroupById.get(pair.groupId);
          if (!group) continue; // backend refers to group we don't show

          const clientInGroup = group.group.find(c => c.id === pair.id);
          if (!clientInGroup) continue; // client not in this group's list

          group.checkcount += 1;
          clientInGroup.boxcheck = true;
          this.allcheckcount += 1;

          const originalClient = clientById.get(pair.id);
          if (originalClient) {
            originalClient.isChecked = true;
          }
        }

        // Same reference as before (change to deep copy if you need a snapshot)
        this.lvrfidgroupclient = this.rfidgroupclient;

        console.log('this.lvrfidgroupclient',this.lvrfidgroupclient);
      } catch (errors) {
        console.log(errors);
      }
    },
    reload_userauth(user_id) {
      // Reset
      this.usergroupclient = [];
      this.lvuserserials = [];
      this.allcheckcount = 0;
      this.usersaved = false;
      this.userchanged = false;
      // User suchen
      const user = this.usertable.find(u => u.userId === user_id);
      if (!user) {
        console.log("User not found:", user_id);
        return;
      }

      // Liste autorisierter Serials extrahieren
      const authorizedSerials = new Set(
        (user.authorizedClients.clients || []).map(a => a.serial)
      );
      this.lvuserserials = user.authorizedClients.clients || [];





      // 1) Gruppenbasis identisch zu reload_pair()
      this.usergroupclient = this.grouptable.map((g, index) => ({
        groupId: g.id,
        name: g.name,
        info: g.info,
        nr: index + 1,
        checkcount: 0,
        group: []
      }));

      // Lookup Map groupId → groupObj
      const groupById = new Map(
        this.usergroupclient.map(g => [g.groupId, g])
      );

      // 2) Clients einsortieren
      for (const client of this.clienttable) {
        const group = groupById.get(client.groupId);
        if (!group) continue;

        group.group.push({
          id: client.id,
          groupId: client.groupId,
          name: client.name,
          serial: client.serial,
          boxcheck: false
        });
      }

      // 3) Leere Gruppen entfernen
      this.usergroupclient = this.usergroupclient.filter(g => g.group.length > 0);

      // Map nach Filter neu erzeugen
      const groupFiltered = new Map(
        this.usergroupclient.map(g => [g.groupId, g])
      );

      // 4) Boxen nach Authorisierung markieren
      for (const group of groupFiltered.values()) {
        for (const box of group.group) {
          if (authorizedSerials.has(box.serial)) {
            box.boxcheck = true;
            const client = this.clienttable.find(c => c.serial === box.serial);
            if (client) {
              client.isUserChecked = true;
            }
            group.checkcount++;
            this.allcheckcount++;
          }
        }
      }
      this.lvusergroupclient = this.usergroupclient;
      console.log('this.lvusergroupclient',this.lvusergroupclient);
      // fertig
    },

    pair_confirm() {
      let eu_cardname_modal = encodeURIComponent(this.cardname_modal);
      this.axios
        .get('wallbox/pairing.php?action=update_pairing&user='+this.$store.state.token+'&token='+this.cardtoken_modal+'&status='+this.cardstatus_modal+'&info='+eu_cardname_modal+'&color='+this.cardcolor_modal.substring(1))
        .then((response) => {
          if(response.data.status=='ok'){
            this.filterpicker(this.filterboxid);
          }else{
            console.log('fehler');
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
      this.pair_modalshow = false;
    },
    userauth_confirm() {
      this.userauth_modalshow = false;
    },
    cancel(close) {
      close()
    },

    async loadMeshData() {
      this.isLoading = true;
      const token = this.$store.state.token;

      try {
        const [
          pairingsData,
          clientsData,
          groupsData,
          usersData,
        ] = await Promise.all([
          this.apiGet('wallbox/pairing.php', { 
            action: 'list_dist_pairings', 
            //typ: this.rfidtype, 
            user: token 
          }),
          this.apiGet('wallbox/client.php', { 
            action: 'get_clients', 
            user: token 
          }),
          this.apiGet('wallbox/client.php', { 
            action: 'get_groups', 
            user: token 
          }),
          this.apiGet('wallbox/user.php', { 
            action: 'user_reload', 
            user: token 
          }),
        ]);

        // 1) Clients & Groups verarbeiten (so wie du es willst)
        this.processClients(clientsData);
        this.processGroups(groupsData);

        // 2) Nur wenn alles OK ist, Tables bauen, Users verarbeiten und dann filterpicker
        if (
          clientsData.status === RESPONSE_OK &&
          groupsData.status === RESPONSE_OK &&
          pairingsData.status === RESPONSE_OK
        ) {
          // 2a) Tabellen bauen
          this.createGroupClientTable();
          this.createRFIDGroupClient();

          // 3) Users verarbeiten (falls async → warten)
          await this.processUsers(usersData, pairingsData, clientsData);

          // 4) Wenn alles fertig: Filter setzen & filterpicker aufrufen
          this.filterboxid = MESH_FILTER_ID;
          this.filterpicker(this.filterboxid);
        } else {
          console.error('Fehler beim Laden der Mesh-Daten', {
            pairingsData,
            clientsData,
            groupsData,
          });
        }
      } catch (error) {
        console.error('Error loading mesh data:', error);
      } finally {
        this.isLoading = false;
      }
    },


    processClients(data) {
      if (data.status === TOKEN_EXPIRED) {
        this.$router.push({ path: '/' });
        return;
      }
      if (data.status === RESPONSE_OK) {
        this.clienttable = data.tbl_clients
          .map(client => ({
            ...client,
            name: this.decodeHtml(client.name),
            info: this.decodeHtml(client.info),
            isChecked: false,
            isUserChecked: false,
          }))
          .sort((a, b) => b.groupId - a.groupId || a.idx - b.idx);
      } else {
        console.error('Error fetching clients data');
      }
    },

    processGroups(data) {
      if (data.status === TOKEN_EXPIRED) {
        this.$router.push({ path: '/' });
        return;
      }
      if (data.status === RESPONSE_OK) {
        this.grouptable = data.tbl_groups.map(group => ({
          ...group,
          name: this.decodeHtml(group.name),
          info: this.decodeHtml(group.info),
        }))
          .sort((a,b) => b.id - a.id);
        if (this.grouptable.length === 1) {
          this.grouptable[0].name = this.$t('pairing.allwallboxes');
        } else {
          this.grouptable[this.grouptable.length - 1].name = this.$t('pairing.noassignment');
        }
      } else {
        console.error('Error fetching groups data');
      }
    },

    processUsers(userdata,rfiddata,clientdata) {
      if (userdata.status === TOKEN_EXPIRED || rfiddata.status === TOKEN_EXPIRED || clientdata.status === TOKEN_EXPIRED) {
        this.$router.push({ path: '/' });
        return;
      }
      if (userdata.status === RESPONSE_OK && rfiddata.status === RESPONSE_OK && clientdata.status === RESPONSE_OK) {
        if (userdata.tbl_user.length === 0) {
          this.usertable = [];
        } else {
          this.usertable = userdata.tbl_user.map(user => {
            const decodedFields = {
              name: this.decodeHtml(user.name),
              alias: this.decodeHtml(user.alias),
              address: this.decodeHtml(user.address),
              reference: this.decodeHtml(user.reference),
              info: this.decodeHtml(user.info),
              email: this.decodeHtml(user.email),
            };

            const creationDate = this.$dayjs(user.creation)
              .subtract(new Date(user.creation).getTimezoneOffset(), 'minute')
              .format('DD.MM.YYYY - HH:mm');

            const rfidtbl = rfiddata?.tbl_remote_pairing
              ? Array.from(
                new Map(
                  rfiddata.tbl_remote_pairing
                    .filter(pair => pair.user === user.userId)
                    .map(pair => [
                      pair.token,
                      {
                        ...pair,
                        info: this.decodeHtml(pair.info),
                      }
                    ])
                ).values()
              )
              : [];

            return {
              ...user,
              ...decodedFields,
              creationoffset: this.$t('common.time', { time: creationDate }),
              isChecked: false,
              showmore: false,
              rfidtbl,
            };
          });
          this.usertable.sort((a, b) => this.sortUsers(a, b));
        }
      } else {
        console.error('Error fetching users data');
      }
    },

    createGroupClientTable() {
      this.groupclienttable = [
        { value: MESH_FILTER_ID, label: 'im Mesh', name: 'im Mesh', icon: 'none', highlight: true, show: true, clientcount: this.clienttable.length },
        { value: ALL_FILTER_ID, label: 'in Gruppe: alle Wallboxen', name: 'Alle Wallboxen', icon: 'none', highlight: true, show: true, clientcount: this.clienttable.length },
      ];

      if (this.grouptable.length === 1) {
        this.clienttable.forEach(box => {
          if (box.wallboxStatus !== NO_CONNECTION_STATUS) {
            this.groupclienttable.push({
              value: `b${box.id}`,
              label: `auf ${box.name}`,
              name: box.name,
              icon: 'none',
              highlight: false,
              show: true,
              clientcount: 1,
            });
          }
        });
      } else {
        this.grouptable.forEach(group => {
          const groupClients = this.clienttable.filter(box => box.groupId === group.id && box.wallboxStatus !== NO_CONNECTION_STATUS);
          this.groupclienttable.push({
            value: `g${group.id}`,
            label: `in ${this.$t('pairing.group')}: ${group.name}`,
            name: `${this.$t('pairing.group')}: ${group.name}`,
            icon: 'none',
            highlight: true,
            show: true,
            clientcount: groupClients.length,
          });

          this.clienttable
            .filter(box => box.groupId === group.id && box.wallboxStatus !== NO_CONNECTION_STATUS)
            .forEach(box => {
              this.groupclienttable.push({
                value: `b${box.id}`,
                label: `auf ${box.name}`,
                name: box.name,
                icon: 'none',
                highlight: false,
                show: true,
                clientcount: 1,
              });
            });
        });

        const lastGroupIndex = this.groupclienttable
          .map(entry => entry.value.startsWith('g'))
          .lastIndexOf(true);
        if (lastGroupIndex !== -1) {
          this.groupclienttable[lastGroupIndex].label = this.$t('pairing.noassignment');
        }
      }
    },

    createRFIDGroupClient() {
      this.rfidgroupclient = this.grouptable.map((group, index) => ({
        groupId: group.id,
        name: group.name,
        info: group.info,
        nr: index + 1,
        checkcount: 0,
        group: this.clienttable
          .filter(client => client.groupId === group.id)
          .map(client => ({
            id: client.id,
            groupId: client.groupId,
            name: client.name,
            boxcheck: false,
          })),
      })).filter(group => group.group.length > 0);
    },

    handleLocalSetup() {
      this.filterboxid = LOCAL_FILTER_ID;
      this.filterpicker(this.filterboxid);
    },

    reloadpage(){
      this.isLoading = true;

      if (this.$store.state.Mesh) {
        this.loadMeshData();
      } else {
        this.handleLocalSetup();
      }
    },
  },
  mounted () {
  },
  beforeUnmount() {
    this.$store.commit('setSortListRfid', this.sortlist);
  },
  created() {
    this.reloadpage();
  },
}
</script>

<style scoped>

</style>
